// Generated from ./util_cohort_builder_grammar/stable/CohortDefinitionLexer.g4 by ANTLR 4.13.1

import * as antlr from "antlr4ng";
import { Token } from "antlr4ng";


export class CohortDefinitionLexer extends antlr.Lexer {
    public static readonly INCLUDE = 1;
    public static readonly EXCLUDE = 2;
    public static readonly STUDY_PERIOD = 3;
    public static readonly BASELINE = 4;
    public static readonly FOLLOW_UP = 5;
    public static readonly INDEX_DATE = 6;
    public static readonly EVENT = 7;
    public static readonly CALENDAR_DATE = 8;
    public static readonly UPPER_DATE_BOUND = 9;
    public static readonly LOWER_DATE_BOUND = 10;
    public static readonly DERIVED_EVENT_DATE = 11;
    public static readonly CONSTRAINTS = 12;
    public static readonly ANY_ORDER = 13;
    public static readonly IS_EVENT_DATE = 14;
    public static readonly TC = 15;
    public static readonly TEMPORAL_CONSTRAINT_ABBR = 16;
    public static readonly TEMPORAL_CONSTRAINT = 17;
    public static readonly POSITION = 18;
    public static readonly CF = 19;
    public static readonly CONCEPT_FILTER = 20;
    public static readonly CONCEPT_FILTER_ABBR = 21;
    public static readonly NF = 22;
    public static readonly NUMERIC_FILTER = 23;
    public static readonly NUMERIC_FILTER_ABBR = 24;
    public static readonly SF = 25;
    public static readonly STRING_FILTER = 26;
    public static readonly STRING_FILTER_ABBR = 27;
    public static readonly UF = 28;
    public static readonly UNIQUENESS_FILTER = 29;
    public static readonly UNIQUENESS_FILTER_ABBR = 30;
    public static readonly RF = 31;
    public static readonly RELATED_ENTITY_FILTER = 32;
    public static readonly RELATED_ENTITY_FILTER_ABBR = 33;
    public static readonly QUALIFIED_CARE_SITE_ALIAS = 34;
    public static readonly QUALIFIED_CONDITION_OCCURRENCE_ALIAS = 35;
    public static readonly QUALIFIED_DRUG_EXPOSURE_ALIAS = 36;
    public static readonly QUALIFIED_MEASUREMENT_ALIAS = 37;
    public static readonly QUALIFIED_OBSERVATION_ALIAS = 38;
    public static readonly QUALIFIED_PERSON_ALIAS = 39;
    public static readonly QUALIFIED_PROCEDURE_OCCURRENCE_ALIAS = 40;
    public static readonly QUALIFIED_PROVIDER_ALIAS = 41;
    public static readonly QUALIFIED_VISIT_OCCURRENCE_ALIAS = 42;
    public static readonly QUALIFIED_DERIVED_EVENT_NAME = 43;
    public static readonly SUBJECT_VARIABLE_CARE_SITE_ALIAS = 44;
    public static readonly SUBJECT_VARIABLE_CONDITION_OCCURRENCE_ALIAS = 45;
    public static readonly SUBJECT_VARIABLE_DRUG_EXPOSURE_ALIAS = 46;
    public static readonly SUBJECT_VARIABLE_MEASUREMENT_ALIAS = 47;
    public static readonly SUBJECT_VARIABLE_OBSERVATION_ALIAS = 48;
    public static readonly SUBJECT_VARIABLE_PROCEDURE_OCCURRENCE_ALIAS = 49;
    public static readonly SUBJECT_VARIABLE_PROVIDER_ALIAS = 50;
    public static readonly SUBJECT_VARIABLE_VISIT_OCCURRENCE_ALIAS = 51;
    public static readonly SUBJECT_VARIABLE_DERIVED_EVENT_NAME = 52;
    public static readonly CONCEPT_GROUP = 53;
    public static readonly CARE_SITE_ALIAS = 54;
    public static readonly CONDITION_OCCURRENCE_ALIAS = 55;
    public static readonly DRUG_EXPOSURE_ALIAS = 56;
    public static readonly MEASUREMENT_ALIAS = 57;
    public static readonly OBSERVATION_ALIAS = 58;
    public static readonly PERSON_ALIAS = 59;
    public static readonly PROCEDURE_OCCURRENCE_ALIAS = 60;
    public static readonly PROVIDER_ALIAS = 61;
    public static readonly VISIT_OCCURRENCE_ALIAS = 62;
    public static readonly MERGED_EVENT_NAME = 63;
    public static readonly SEQUENCE_EVENT_NAME = 64;
    public static readonly INSTANCE_EVENT_NAME = 65;
    public static readonly SUBJECTS_VARIABLE_NAME = 66;
    public static readonly NAMESPACE_QUALIFIER = 67;
    public static readonly SUBJECTS_VARIABLE = 68;
    public static readonly CONCEPT = 69;
    public static readonly QUALIFIED_MERGED_EVENT = 70;
    public static readonly QUALIFIED_SEQUENCE_EVENT = 71;
    public static readonly QUALIFIED_INSTANCE_EVENT = 72;
    public static readonly SUBJECT_VARIABLE_MERGED_EVENT = 73;
    public static readonly SUBJECT_VARIABLE_SEQUENCE_EVENT = 74;
    public static readonly SUBJECT_VARIABLE_INSTANCE_EVENT = 75;
    public static readonly MERGED_EVENT = 76;
    public static readonly SEQUENCE_EVENT = 77;
    public static readonly INSTANCE_EVENT = 78;
    public static readonly DERIVED_EVENT = 79;
    public static readonly LINE_COMMENT = 80;
    public static readonly INT = 81;
    public static readonly M = 82;
    public static readonly D = 83;
    public static readonly Y = 84;
    public static readonly DATE = 85;
    public static readonly OPEN_PAREN = 86;
    public static readonly CLOSE_PAREN = 87;
    public static readonly SEMICOLON = 88;
    public static readonly COMMA = 89;
    public static readonly EQ = 90;
    public static readonly MULTIPLY = 91;
    public static readonly DIVIDE = 92;
    public static readonly ADD = 93;
    public static readonly SUBTRACT = 94;
    public static readonly CONTAINS = 95;
    public static readonly NEQ = 96;
    public static readonly LTE = 97;
    public static readonly GTE = 98;
    public static readonly LT = 99;
    public static readonly GT = 100;
    public static readonly MAX = 101;
    public static readonly MIN = 102;
    public static readonly AVG = 103;
    public static readonly COUNT = 104;
    public static readonly LEAST = 105;
    public static readonly GREATEST = 106;
    public static readonly IN = 107;
    public static readonly AND = 108;
    public static readonly OR = 109;
    public static readonly NOT = 110;
    public static readonly COMPLEMENT = 111;
    public static readonly UNION = 112;
    public static readonly INTERSECTION = 113;
    public static readonly DIFFERENCE = 114;
    public static readonly INDEX = 115;
    public static readonly TIME_UNIT = 116;
    public static readonly DAYS = 117;
    public static readonly WEEKS = 118;
    public static readonly MONTHS = 119;
    public static readonly YEARS = 120;
    public static readonly MINIMUM_BETWEEN = 121;
    public static readonly MAXIMUM_BETWEEN = 122;
    public static readonly TOTAL_BETWEEN = 123;
    public static readonly FIXED_WINDOW = 124;
    public static readonly ROLLING_WINDOW = 125;
    public static readonly PERIOD = 126;
    public static readonly WS = 127;
    public static readonly CARE_SITE = 128;
    public static readonly CONDITION_OCCURRENCE = 129;
    public static readonly DRUG_EXPOSURE = 130;
    public static readonly MEASUREMENT = 131;
    public static readonly OBSERVATION = 132;
    public static readonly PERSON = 133;
    public static readonly PROCEDURE_OCCURRENCE = 134;
    public static readonly PROVIDER = 135;
    public static readonly VISIT_OCCURRENCE = 136;
    public static readonly QUALIFIED_CARE_SITE = 137;
    public static readonly QUALIFIED_CONDITION_OCCURRENCE = 138;
    public static readonly QUALIFIED_DRUG_EXPOSURE = 139;
    public static readonly QUALIFIED_MEASUREMENT = 140;
    public static readonly QUALIFIED_OBSERVATION = 141;
    public static readonly QUALIFIED_PERSON = 142;
    public static readonly QUALIFIED_PROCEDURE_OCCURRENCE = 143;
    public static readonly QUALIFIED_PROVIDER = 144;
    public static readonly QUALIFIED_VISIT_OCCURRENCE = 145;
    public static readonly SUBJECT_VARIABLE_CARE_SITE = 146;
    public static readonly SUBJECT_VARIABLE_CONDITION_OCCURRENCE = 147;
    public static readonly SUBJECT_VARIABLE_DRUG_EXPOSURE = 148;
    public static readonly SUBJECT_VARIABLE_MEASUREMENT = 149;
    public static readonly SUBJECT_VARIABLE_OBSERVATION = 150;
    public static readonly SUBJECT_VARIABLE_PERSON = 151;
    public static readonly SUBJECT_VARIABLE_PROCEDURE_OCCURRENCE = 152;
    public static readonly SUBJECT_VARIABLE_PROVIDER = 153;
    public static readonly SUBJECT_VARIABLE_VISIT_OCCURRENCE = 154;
    public static readonly CONDITION_OCCURRENCE_DATE_ATTRIBUTE = 155;
    public static readonly DRUG_EXPOSURE_DATE_ATTRIBUTE = 156;
    public static readonly MEASUREMENT_DATE_ATTRIBUTE = 157;
    public static readonly OBSERVATION_DATE_ATTRIBUTE = 158;
    public static readonly PROCEDURE_OCCURRENCE_DATE_ATTRIBUTE = 159;
    public static readonly VISIT_OCCURRENCE_DATE_ATTRIBUTE = 160;
    public static readonly PERSON_DATE_TIME_ATTRIBUTE = 161;
    public static readonly DRUG_EXPOSURE_INT_ATTRIBUTE = 162;
    public static readonly MEASUREMENT_FLOAT_ATTRIBUTE = 163;
    public static readonly PERSON_INT_ATTRIBUTE = 164;
    public static readonly COMMON_NUMERIC_FLOAT_ATTRIBUTE = 165;
    public static readonly QUANTITY = 166;
    public static readonly CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE = 167;
    public static readonly DRUG_EXPOSURE_CONCEPT_ATTRIBUTE = 168;
    public static readonly MEASUREMENT_CONCEPT_ATTRIBUTE = 169;
    public static readonly OBSERVATION_CONCEPT_ATTRIBUTE = 170;
    public static readonly PERSON_CONCEPT_ATTRIBUTE = 171;
    public static readonly PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE = 172;
    public static readonly PROVIDER_CONCEPT_ATTRIBUTE = 173;
    public static readonly VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE = 174;
    public static readonly COMMON_CONCEPT_ATTRIBUTE = 175;
    public static readonly CARE_SITE_CONCEPT_ATTRIBUTE = 176;
    public static readonly COMMON_STRING_ATTRIBUTE = 177;
    public static readonly GENDER_SOURCE_VALUE = 178;
    public static readonly CARE_SITE_STRING_ATTRIBUTE = 179;
    public static readonly CONDITION_OCCURRENCE_STRING_ATTRIBUTE = 180;
    public static readonly DRUG_EXPOSURE_STRING_ATTRIBUTE = 181;
    public static readonly MEASUREMENT_STRING_ATTRIBUTE = 182;
    public static readonly OBSERVATION_STRING_ATTRIBUTE = 183;
    public static readonly PERSON_STRING_ATTRIBUTE = 184;
    public static readonly PROCEDURE_OCCURRENCE_STRING_ATTRIBUTE = 185;
    public static readonly PROVIDER_STRING_ATTRIBUTE = 186;
    public static readonly VISIT_OCCURRENCE_STRING_ATTRIBUTE = 187;

    public static readonly channelNames = [
        "DEFAULT_TOKEN_CHANNEL", "HIDDEN"
    ];

    public static readonly literalNames = [
        null, "'INCLUDE'", "'EXCLUDE'", "'STUDY_PERIOD'", "'BASELINE'", 
        "'FOLLOW_UP'", "'INDEX_DATE'", "'EVENT'", "'CALENDAR_DATE'", "'UPPER_DATE_BOUND'", 
        "'LOWER_DATE_BOUND'", "'derived_event_date'", "'CONSTRAINTS'", "'ANY_ORDER'", 
        "'IS_EVENT_DATE'", null, "'TC'", "'TEMPORAL_CONSTRAINT'", "'POSITION'", 
        null, "'CONCEPT_FILTER'", "'CF'", null, "'NUMERIC_FILTER'", "'NF'", 
        null, "'STRING_FILTER'", "'SF'", null, "'UNIQUENESS_FILTER'", "'UF'", 
        null, "'RELATED_ENTITY_FILTER'", "'RF'", null, null, null, null, 
        null, null, null, null, null, null, null, null, null, null, null, 
        null, null, null, null, null, null, null, null, null, null, null, 
        null, null, null, null, null, null, null, "'::'", "'SUBJECTS_VARIABLE'", 
        null, "'QUALIFIED_MERGED_EVENT'", "'QUALIFIED_SEQUENCE_EVENT'", 
        "'QUALIFIED_INSTANCE_EVENT'", "'SUBJECT_VARIABLE_MERGED_EVENT'", 
        "'SUBJECT_VARIABLE_SEQUENCE_EVENT'", "'SUBJECT_VARIABLE_INSTANCE_EVENT'", 
        "'MERGED_EVENT'", "'SEQUENCE_EVENT'", "'INSTANCE_EVENT'", "'DERIVED_EVENT'", 
        null, null, null, null, null, null, "'('", "')'", "';'", "','", 
        "'='", "'*'", "'/'", "'+'", "'-'", "'CONTAINS'", "'!='", "'<='", 
        "'>='", "'<'", "'>'", "'MAX'", "'MIN'", "'AVG'", "'COUNT'", "'LEAST'", 
        "'GREATEST'", "'IN'", "'AND'", "'OR'", "'NOT'", "'COMPLEMENT'", 
        "'UNION'", "'INTERSECTION'", "'DIFFERENCE'", "'INDEX'", null, "'DAYS'", 
        "'WEEKS'", "'MONTHS'", "'YEARS'", "'MINIMUM_BETWEEN'", "'MAXIMUM_BETWEEN'", 
        "'TOTAL_BETWEEN'", "'FIXED_WINDOW'", "'ROLLING_WINDOW'", "'.'", 
        null, "'CARE_SITE'", "'CONDITION_OCCURRENCE'", "'DRUG_EXPOSURE'", 
        "'MEASUREMENT'", "'OBSERVATION'", "'PERSON'", "'PROCEDURE_OCCURRENCE'", 
        "'PROVIDER'", "'VISIT_OCCURRENCE'", "'QUALIFIED_CARE_SITE'", "'QUALIFIED_CONDITION_OCCURRENCE'", 
        "'QUALIFIED_DRUG_EXPOSURE'", "'QUALIFIED_MEASUREMENT'", "'QUALIFIED_OBSERVATION'", 
        "'QUALIFIED_PERSON'", "'QUALIFIED_PROCEDURE_OCCURRENCE'", "'QUALIFIED_PROVIDER'", 
        "'QUALIFIED_VISIT_OCCURRENCE'", "'SUBJECT_VARIABLE_CARE_SITE'", 
        "'SUBJECT_VARIABLE_CONDITION_OCCURRENCE'", "'SUBJECT_VARIABLE_DRUG_EXPOSURE'", 
        "'SUBJECT_VARIABLE_MEASUREMENT'", "'SUBJECT_VARIABLE_OBSERVATION'", 
        "'SUBJECT_VARIABLE_PERSON'", "'SUBJECT_VARIABLE_PROCEDURE_OCCURRENCE'", 
        "'SUBJECT_VARIABLE_PROVIDER'", "'SUBJECT_VARIABLE_VISIT_OCCURRENCE'", 
        null, null, "'measurement_date'", "'observation_date'", "'procedure_date'", 
        null, "'birth_datetime'", null, null, null, "'value_as_number'", 
        "'quantity'", null, null, null, null, null, null, "'specialty_concept'", 
        null, null, "'place_of_service_concept'", "'value_as_string'", "'gender_source_value'"
    ];

    public static readonly symbolicNames = [
        null, "INCLUDE", "EXCLUDE", "STUDY_PERIOD", "BASELINE", "FOLLOW_UP", 
        "INDEX_DATE", "EVENT", "CALENDAR_DATE", "UPPER_DATE_BOUND", "LOWER_DATE_BOUND", 
        "DERIVED_EVENT_DATE", "CONSTRAINTS", "ANY_ORDER", "IS_EVENT_DATE", 
        "TC", "TEMPORAL_CONSTRAINT_ABBR", "TEMPORAL_CONSTRAINT", "POSITION", 
        "CF", "CONCEPT_FILTER", "CONCEPT_FILTER_ABBR", "NF", "NUMERIC_FILTER", 
        "NUMERIC_FILTER_ABBR", "SF", "STRING_FILTER", "STRING_FILTER_ABBR", 
        "UF", "UNIQUENESS_FILTER", "UNIQUENESS_FILTER_ABBR", "RF", "RELATED_ENTITY_FILTER", 
        "RELATED_ENTITY_FILTER_ABBR", "QUALIFIED_CARE_SITE_ALIAS", "QUALIFIED_CONDITION_OCCURRENCE_ALIAS", 
        "QUALIFIED_DRUG_EXPOSURE_ALIAS", "QUALIFIED_MEASUREMENT_ALIAS", 
        "QUALIFIED_OBSERVATION_ALIAS", "QUALIFIED_PERSON_ALIAS", "QUALIFIED_PROCEDURE_OCCURRENCE_ALIAS", 
        "QUALIFIED_PROVIDER_ALIAS", "QUALIFIED_VISIT_OCCURRENCE_ALIAS", 
        "QUALIFIED_DERIVED_EVENT_NAME", "SUBJECT_VARIABLE_CARE_SITE_ALIAS", 
        "SUBJECT_VARIABLE_CONDITION_OCCURRENCE_ALIAS", "SUBJECT_VARIABLE_DRUG_EXPOSURE_ALIAS", 
        "SUBJECT_VARIABLE_MEASUREMENT_ALIAS", "SUBJECT_VARIABLE_OBSERVATION_ALIAS", 
        "SUBJECT_VARIABLE_PROCEDURE_OCCURRENCE_ALIAS", "SUBJECT_VARIABLE_PROVIDER_ALIAS", 
        "SUBJECT_VARIABLE_VISIT_OCCURRENCE_ALIAS", "SUBJECT_VARIABLE_DERIVED_EVENT_NAME", 
        "CONCEPT_GROUP", "CARE_SITE_ALIAS", "CONDITION_OCCURRENCE_ALIAS", 
        "DRUG_EXPOSURE_ALIAS", "MEASUREMENT_ALIAS", "OBSERVATION_ALIAS", 
        "PERSON_ALIAS", "PROCEDURE_OCCURRENCE_ALIAS", "PROVIDER_ALIAS", 
        "VISIT_OCCURRENCE_ALIAS", "MERGED_EVENT_NAME", "SEQUENCE_EVENT_NAME", 
        "INSTANCE_EVENT_NAME", "SUBJECTS_VARIABLE_NAME", "NAMESPACE_QUALIFIER", 
        "SUBJECTS_VARIABLE", "CONCEPT", "QUALIFIED_MERGED_EVENT", "QUALIFIED_SEQUENCE_EVENT", 
        "QUALIFIED_INSTANCE_EVENT", "SUBJECT_VARIABLE_MERGED_EVENT", "SUBJECT_VARIABLE_SEQUENCE_EVENT", 
        "SUBJECT_VARIABLE_INSTANCE_EVENT", "MERGED_EVENT", "SEQUENCE_EVENT", 
        "INSTANCE_EVENT", "DERIVED_EVENT", "LINE_COMMENT", "INT", "M", "D", 
        "Y", "DATE", "OPEN_PAREN", "CLOSE_PAREN", "SEMICOLON", "COMMA", 
        "EQ", "MULTIPLY", "DIVIDE", "ADD", "SUBTRACT", "CONTAINS", "NEQ", 
        "LTE", "GTE", "LT", "GT", "MAX", "MIN", "AVG", "COUNT", "LEAST", 
        "GREATEST", "IN", "AND", "OR", "NOT", "COMPLEMENT", "UNION", "INTERSECTION", 
        "DIFFERENCE", "INDEX", "TIME_UNIT", "DAYS", "WEEKS", "MONTHS", "YEARS", 
        "MINIMUM_BETWEEN", "MAXIMUM_BETWEEN", "TOTAL_BETWEEN", "FIXED_WINDOW", 
        "ROLLING_WINDOW", "PERIOD", "WS", "CARE_SITE", "CONDITION_OCCURRENCE", 
        "DRUG_EXPOSURE", "MEASUREMENT", "OBSERVATION", "PERSON", "PROCEDURE_OCCURRENCE", 
        "PROVIDER", "VISIT_OCCURRENCE", "QUALIFIED_CARE_SITE", "QUALIFIED_CONDITION_OCCURRENCE", 
        "QUALIFIED_DRUG_EXPOSURE", "QUALIFIED_MEASUREMENT", "QUALIFIED_OBSERVATION", 
        "QUALIFIED_PERSON", "QUALIFIED_PROCEDURE_OCCURRENCE", "QUALIFIED_PROVIDER", 
        "QUALIFIED_VISIT_OCCURRENCE", "SUBJECT_VARIABLE_CARE_SITE", "SUBJECT_VARIABLE_CONDITION_OCCURRENCE", 
        "SUBJECT_VARIABLE_DRUG_EXPOSURE", "SUBJECT_VARIABLE_MEASUREMENT", 
        "SUBJECT_VARIABLE_OBSERVATION", "SUBJECT_VARIABLE_PERSON", "SUBJECT_VARIABLE_PROCEDURE_OCCURRENCE", 
        "SUBJECT_VARIABLE_PROVIDER", "SUBJECT_VARIABLE_VISIT_OCCURRENCE", 
        "CONDITION_OCCURRENCE_DATE_ATTRIBUTE", "DRUG_EXPOSURE_DATE_ATTRIBUTE", 
        "MEASUREMENT_DATE_ATTRIBUTE", "OBSERVATION_DATE_ATTRIBUTE", "PROCEDURE_OCCURRENCE_DATE_ATTRIBUTE", 
        "VISIT_OCCURRENCE_DATE_ATTRIBUTE", "PERSON_DATE_TIME_ATTRIBUTE", 
        "DRUG_EXPOSURE_INT_ATTRIBUTE", "MEASUREMENT_FLOAT_ATTRIBUTE", "PERSON_INT_ATTRIBUTE", 
        "COMMON_NUMERIC_FLOAT_ATTRIBUTE", "QUANTITY", "CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE", 
        "DRUG_EXPOSURE_CONCEPT_ATTRIBUTE", "MEASUREMENT_CONCEPT_ATTRIBUTE", 
        "OBSERVATION_CONCEPT_ATTRIBUTE", "PERSON_CONCEPT_ATTRIBUTE", "PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE", 
        "PROVIDER_CONCEPT_ATTRIBUTE", "VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE", 
        "COMMON_CONCEPT_ATTRIBUTE", "CARE_SITE_CONCEPT_ATTRIBUTE", "COMMON_STRING_ATTRIBUTE", 
        "GENDER_SOURCE_VALUE", "CARE_SITE_STRING_ATTRIBUTE", "CONDITION_OCCURRENCE_STRING_ATTRIBUTE", 
        "DRUG_EXPOSURE_STRING_ATTRIBUTE", "MEASUREMENT_STRING_ATTRIBUTE", 
        "OBSERVATION_STRING_ATTRIBUTE", "PERSON_STRING_ATTRIBUTE", "PROCEDURE_OCCURRENCE_STRING_ATTRIBUTE", 
        "PROVIDER_STRING_ATTRIBUTE", "VISIT_OCCURRENCE_STRING_ATTRIBUTE"
    ];

    public static readonly modeNames = [
        "DEFAULT_MODE",
    ];

    public static readonly ruleNames = [
        "INCLUDE", "EXCLUDE", "STUDY_PERIOD", "BASELINE", "FOLLOW_UP", "INDEX_DATE", 
        "EVENT", "CALENDAR_DATE", "UPPER_DATE_BOUND", "LOWER_DATE_BOUND", 
        "DERIVED_EVENT_DATE", "CONSTRAINTS", "ANY_ORDER", "IS_EVENT_DATE", 
        "TC", "TEMPORAL_CONSTRAINT_ABBR", "TEMPORAL_CONSTRAINT", "POSITION", 
        "CF", "CONCEPT_FILTER", "CONCEPT_FILTER_ABBR", "NF", "NUMERIC_FILTER", 
        "NUMERIC_FILTER_ABBR", "SF", "STRING_FILTER", "STRING_FILTER_ABBR", 
        "UF", "UNIQUENESS_FILTER", "UNIQUENESS_FILTER_ABBR", "RF", "RELATED_ENTITY_FILTER", 
        "RELATED_ENTITY_FILTER_ABBR", "QUALIFIED_CARE_SITE_ALIAS", "QUALIFIED_CONDITION_OCCURRENCE_ALIAS", 
        "QUALIFIED_DRUG_EXPOSURE_ALIAS", "QUALIFIED_MEASUREMENT_ALIAS", 
        "QUALIFIED_OBSERVATION_ALIAS", "QUALIFIED_PERSON_ALIAS", "QUALIFIED_PROCEDURE_OCCURRENCE_ALIAS", 
        "QUALIFIED_PROVIDER_ALIAS", "QUALIFIED_VISIT_OCCURRENCE_ALIAS", 
        "QUALIFIED_DERIVED_EVENT_NAME", "SUBJECT_VARIABLE_CARE_SITE_ALIAS", 
        "SUBJECT_VARIABLE_CONDITION_OCCURRENCE_ALIAS", "SUBJECT_VARIABLE_DRUG_EXPOSURE_ALIAS", 
        "SUBJECT_VARIABLE_MEASUREMENT_ALIAS", "SUBJECT_VARIABLE_OBSERVATION_ALIAS", 
        "SUBJECT_VARIABLE_PROCEDURE_OCCURRENCE_ALIAS", "SUBJECT_VARIABLE_PROVIDER_ALIAS", 
        "SUBJECT_VARIABLE_VISIT_OCCURRENCE_ALIAS", "SUBJECT_VARIABLE_DERIVED_EVENT_NAME", 
        "CONCEPT_GROUP", "CARE_SITE_ALIAS", "CONDITION_OCCURRENCE_ALIAS", 
        "DRUG_EXPOSURE_ALIAS", "MEASUREMENT_ALIAS", "OBSERVATION_ALIAS", 
        "PERSON_ALIAS", "PROCEDURE_OCCURRENCE_ALIAS", "PROVIDER_ALIAS", 
        "VISIT_OCCURRENCE_ALIAS", "MERGED_EVENT_NAME", "SEQUENCE_EVENT_NAME", 
        "INSTANCE_EVENT_NAME", "SUBJECTS_VARIABLE_NAME", "NAMESPACE_QUALIFIER", 
        "SUBJECTS_VARIABLE", "CONCEPT", "QUALIFIED_MERGED_EVENT", "QUALIFIED_SEQUENCE_EVENT", 
        "QUALIFIED_INSTANCE_EVENT", "SUBJECT_VARIABLE_MERGED_EVENT", "SUBJECT_VARIABLE_SEQUENCE_EVENT", 
        "SUBJECT_VARIABLE_INSTANCE_EVENT", "MERGED_EVENT", "SEQUENCE_EVENT", 
        "INSTANCE_EVENT", "DERIVED_EVENT", "LINE_COMMENT", "INT", "M", "D", 
        "Y", "DATE", "OPEN_PAREN", "CLOSE_PAREN", "SEMICOLON", "COMMA", 
        "LABEL", "ALPHA", "ALPHA_NUMERIC", "NON_ALPHA_NUMERIC", "SPECIAL_CHAR", 
        "EQ", "MULTIPLY", "DIVIDE", "ADD", "SUBTRACT", "CONTAINS", "NEQ", 
        "LTE", "GTE", "LT", "GT", "MAX", "MIN", "AVG", "COUNT", "LEAST", 
        "GREATEST", "IN", "AND", "OR", "NOT", "COMPLEMENT", "UNION", "INTERSECTION", 
        "DIFFERENCE", "INDEX", "TIME_UNIT", "DAYS", "WEEKS", "MONTHS", "YEARS", 
        "MINIMUM_BETWEEN", "MAXIMUM_BETWEEN", "TOTAL_BETWEEN", "FIXED_WINDOW", 
        "ROLLING_WINDOW", "PERIOD", "WS", "CARE_SITE", "CONDITION_OCCURRENCE", 
        "DRUG_EXPOSURE", "MEASUREMENT", "OBSERVATION", "PERSON", "PROCEDURE_OCCURRENCE", 
        "PROVIDER", "VISIT_OCCURRENCE", "QUALIFIED_CARE_SITE", "QUALIFIED_CONDITION_OCCURRENCE", 
        "QUALIFIED_DRUG_EXPOSURE", "QUALIFIED_MEASUREMENT", "QUALIFIED_OBSERVATION", 
        "QUALIFIED_PERSON", "QUALIFIED_PROCEDURE_OCCURRENCE", "QUALIFIED_PROVIDER", 
        "QUALIFIED_VISIT_OCCURRENCE", "SUBJECT_VARIABLE_CARE_SITE", "SUBJECT_VARIABLE_CONDITION_OCCURRENCE", 
        "SUBJECT_VARIABLE_DRUG_EXPOSURE", "SUBJECT_VARIABLE_MEASUREMENT", 
        "SUBJECT_VARIABLE_OBSERVATION", "SUBJECT_VARIABLE_PERSON", "SUBJECT_VARIABLE_PROCEDURE_OCCURRENCE", 
        "SUBJECT_VARIABLE_PROVIDER", "SUBJECT_VARIABLE_VISIT_OCCURRENCE", 
        "CONDITION_OCCURRENCE_DATE_ATTRIBUTE", "DRUG_EXPOSURE_DATE_ATTRIBUTE", 
        "MEASUREMENT_DATE_ATTRIBUTE", "OBSERVATION_DATE_ATTRIBUTE", "PROCEDURE_OCCURRENCE_DATE_ATTRIBUTE", 
        "VISIT_OCCURRENCE_DATE_ATTRIBUTE", "PERSON_DATE_TIME_ATTRIBUTE", 
        "DRUG_EXPOSURE_INT_ATTRIBUTE", "MEASUREMENT_FLOAT_ATTRIBUTE", "PERSON_INT_ATTRIBUTE", 
        "COMMON_NUMERIC_FLOAT_ATTRIBUTE", "QUANTITY", "CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE", 
        "DRUG_EXPOSURE_CONCEPT_ATTRIBUTE", "MEASUREMENT_CONCEPT_ATTRIBUTE", 
        "OBSERVATION_CONCEPT_ATTRIBUTE", "PERSON_CONCEPT_ATTRIBUTE", "PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE", 
        "PROVIDER_CONCEPT_ATTRIBUTE", "VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE", 
        "COMMON_CONCEPT_ATTRIBUTE", "CARE_SITE_CONCEPT_ATTRIBUTE", "COMMON_STRING_ATTRIBUTE", 
        "GENDER_SOURCE_VALUE", "CARE_SITE_STRING_ATTRIBUTE", "CONDITION_OCCURRENCE_STRING_ATTRIBUTE", 
        "DRUG_EXPOSURE_STRING_ATTRIBUTE", "MEASUREMENT_STRING_ATTRIBUTE", 
        "OBSERVATION_STRING_ATTRIBUTE", "PERSON_STRING_ATTRIBUTE", "PROCEDURE_OCCURRENCE_STRING_ATTRIBUTE", 
        "PROVIDER_STRING_ATTRIBUTE", "VISIT_OCCURRENCE_STRING_ATTRIBUTE",
    ];


    public constructor(input: antlr.CharStream) {
        super(input);
        this.interpreter = new antlr.LexerATNSimulator(this, CohortDefinitionLexer._ATN, CohortDefinitionLexer.decisionsToDFA, new antlr.PredictionContextCache());
    }

    public get grammarFileName(): string { return "CohortDefinitionLexer.g4"; }

    public get literalNames(): (string | null)[] { return CohortDefinitionLexer.literalNames; }
    public get symbolicNames(): (string | null)[] { return CohortDefinitionLexer.symbolicNames; }
    public get ruleNames(): string[] { return CohortDefinitionLexer.ruleNames; }

    public get serializedATN(): number[] { return CohortDefinitionLexer._serializedATN; }

    public get channelNames(): string[] { return CohortDefinitionLexer.channelNames; }

    public get modeNames(): string[] { return CohortDefinitionLexer.modeNames; }

    public static readonly _serializedATN: number[] = [
        4,0,187,3458,6,-1,2,0,7,0,2,1,7,1,2,2,7,2,2,3,7,3,2,4,7,4,2,5,7,
        5,2,6,7,6,2,7,7,7,2,8,7,8,2,9,7,9,2,10,7,10,2,11,7,11,2,12,7,12,
        2,13,7,13,2,14,7,14,2,15,7,15,2,16,7,16,2,17,7,17,2,18,7,18,2,19,
        7,19,2,20,7,20,2,21,7,21,2,22,7,22,2,23,7,23,2,24,7,24,2,25,7,25,
        2,26,7,26,2,27,7,27,2,28,7,28,2,29,7,29,2,30,7,30,2,31,7,31,2,32,
        7,32,2,33,7,33,2,34,7,34,2,35,7,35,2,36,7,36,2,37,7,37,2,38,7,38,
        2,39,7,39,2,40,7,40,2,41,7,41,2,42,7,42,2,43,7,43,2,44,7,44,2,45,
        7,45,2,46,7,46,2,47,7,47,2,48,7,48,2,49,7,49,2,50,7,50,2,51,7,51,
        2,52,7,52,2,53,7,53,2,54,7,54,2,55,7,55,2,56,7,56,2,57,7,57,2,58,
        7,58,2,59,7,59,2,60,7,60,2,61,7,61,2,62,7,62,2,63,7,63,2,64,7,64,
        2,65,7,65,2,66,7,66,2,67,7,67,2,68,7,68,2,69,7,69,2,70,7,70,2,71,
        7,71,2,72,7,72,2,73,7,73,2,74,7,74,2,75,7,75,2,76,7,76,2,77,7,77,
        2,78,7,78,2,79,7,79,2,80,7,80,2,81,7,81,2,82,7,82,2,83,7,83,2,84,
        7,84,2,85,7,85,2,86,7,86,2,87,7,87,2,88,7,88,2,89,7,89,2,90,7,90,
        2,91,7,91,2,92,7,92,2,93,7,93,2,94,7,94,2,95,7,95,2,96,7,96,2,97,
        7,97,2,98,7,98,2,99,7,99,2,100,7,100,2,101,7,101,2,102,7,102,2,103,
        7,103,2,104,7,104,2,105,7,105,2,106,7,106,2,107,7,107,2,108,7,108,
        2,109,7,109,2,110,7,110,2,111,7,111,2,112,7,112,2,113,7,113,2,114,
        7,114,2,115,7,115,2,116,7,116,2,117,7,117,2,118,7,118,2,119,7,119,
        2,120,7,120,2,121,7,121,2,122,7,122,2,123,7,123,2,124,7,124,2,125,
        7,125,2,126,7,126,2,127,7,127,2,128,7,128,2,129,7,129,2,130,7,130,
        2,131,7,131,2,132,7,132,2,133,7,133,2,134,7,134,2,135,7,135,2,136,
        7,136,2,137,7,137,2,138,7,138,2,139,7,139,2,140,7,140,2,141,7,141,
        2,142,7,142,2,143,7,143,2,144,7,144,2,145,7,145,2,146,7,146,2,147,
        7,147,2,148,7,148,2,149,7,149,2,150,7,150,2,151,7,151,2,152,7,152,
        2,153,7,153,2,154,7,154,2,155,7,155,2,156,7,156,2,157,7,157,2,158,
        7,158,2,159,7,159,2,160,7,160,2,161,7,161,2,162,7,162,2,163,7,163,
        2,164,7,164,2,165,7,165,2,166,7,166,2,167,7,167,2,168,7,168,2,169,
        7,169,2,170,7,170,2,171,7,171,2,172,7,172,2,173,7,173,2,174,7,174,
        2,175,7,175,2,176,7,176,2,177,7,177,2,178,7,178,2,179,7,179,2,180,
        7,180,2,181,7,181,2,182,7,182,2,183,7,183,2,184,7,184,2,185,7,185,
        2,186,7,186,2,187,7,187,2,188,7,188,2,189,7,189,2,190,7,190,2,191,
        7,191,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,1,1,1,1,1,1,1,1,1,1,1,1,
        1,1,1,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,3,1,
        3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,
        4,1,4,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,6,1,6,1,6,1,
        6,1,6,1,6,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,
        7,1,8,1,8,1,8,1,8,1,8,1,8,1,8,1,8,1,8,1,8,1,8,1,8,1,8,1,8,1,8,1,
        8,1,8,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,
        9,1,9,1,9,1,10,1,10,1,10,1,10,1,10,1,10,1,10,1,10,1,10,1,10,1,10,
        1,10,1,10,1,10,1,10,1,10,1,10,1,10,1,10,1,11,1,11,1,11,1,11,1,11,
        1,11,1,11,1,11,1,11,1,11,1,11,1,11,1,12,1,12,1,12,1,12,1,12,1,12,
        1,12,1,12,1,12,1,12,1,13,1,13,1,13,1,13,1,13,1,13,1,13,1,13,1,13,
        1,13,1,13,1,13,1,13,1,13,1,14,1,14,3,14,556,8,14,1,15,1,15,1,15,
        1,16,1,16,1,16,1,16,1,16,1,16,1,16,1,16,1,16,1,16,1,16,1,16,1,16,
        1,16,1,16,1,16,1,16,1,16,1,16,1,16,1,17,1,17,1,17,1,17,1,17,1,17,
        1,17,1,17,1,17,1,18,1,18,3,18,592,8,18,1,19,1,19,1,19,1,19,1,19,
        1,19,1,19,1,19,1,19,1,19,1,19,1,19,1,19,1,19,1,19,1,20,1,20,1,20,
        1,21,1,21,3,21,614,8,21,1,22,1,22,1,22,1,22,1,22,1,22,1,22,1,22,
        1,22,1,22,1,22,1,22,1,22,1,22,1,22,1,23,1,23,1,23,1,24,1,24,3,24,
        636,8,24,1,25,1,25,1,25,1,25,1,25,1,25,1,25,1,25,1,25,1,25,1,25,
        1,25,1,25,1,25,1,26,1,26,1,26,1,27,1,27,3,27,657,8,27,1,28,1,28,
        1,28,1,28,1,28,1,28,1,28,1,28,1,28,1,28,1,28,1,28,1,28,1,28,1,28,
        1,28,1,28,1,28,1,29,1,29,1,29,1,30,1,30,3,30,682,8,30,1,31,1,31,
        1,31,1,31,1,31,1,31,1,31,1,31,1,31,1,31,1,31,1,31,1,31,1,31,1,31,
        1,31,1,31,1,31,1,31,1,31,1,31,1,31,1,32,1,32,1,32,1,33,1,33,1,33,
        1,33,1,34,1,34,1,34,1,34,1,35,1,35,1,35,1,35,1,36,1,36,1,36,1,36,
        1,37,1,37,1,37,1,37,1,38,1,38,1,38,1,38,1,39,1,39,1,39,1,39,1,40,
        1,40,1,40,1,40,1,41,1,41,1,41,1,41,1,42,1,42,1,42,3,42,748,8,42,
        1,42,1,42,1,42,1,43,1,43,1,43,1,43,1,44,1,44,1,44,1,44,1,45,1,45,
        1,45,1,45,1,46,1,46,1,46,1,46,1,47,1,47,1,47,1,47,1,48,1,48,1,48,
        1,48,1,49,1,49,1,49,1,49,1,50,1,50,1,50,1,50,1,51,1,51,1,51,3,51,
        788,8,51,1,51,1,51,1,51,1,52,1,52,1,52,1,52,1,52,1,52,1,52,1,52,
        1,52,1,52,1,52,1,52,1,52,1,52,1,52,1,52,1,52,1,53,1,53,1,53,1,53,
        1,54,1,54,1,54,1,54,1,55,1,55,1,55,1,55,1,56,1,56,1,56,1,56,1,57,
        1,57,1,57,1,57,1,58,1,58,1,58,1,58,1,59,1,59,1,59,1,59,1,60,1,60,
        1,60,1,60,1,61,1,61,1,61,1,61,1,62,1,62,1,62,1,62,1,63,1,63,1,63,
        1,63,1,64,1,64,1,64,1,64,1,65,1,65,1,65,1,65,1,66,1,66,1,66,1,67,
        1,67,1,67,1,67,1,67,1,67,1,67,1,67,1,67,1,67,1,67,1,67,1,67,1,67,
        1,67,1,67,1,67,1,67,1,68,4,68,884,8,68,11,68,12,68,885,1,68,1,68,
        4,68,890,8,68,11,68,12,68,891,1,69,1,69,1,69,1,69,1,69,1,69,1,69,
        1,69,1,69,1,69,1,69,1,69,1,69,1,69,1,69,1,69,1,69,1,69,1,69,1,69,
        1,69,1,69,1,69,1,70,1,70,1,70,1,70,1,70,1,70,1,70,1,70,1,70,1,70,
        1,70,1,70,1,70,1,70,1,70,1,70,1,70,1,70,1,70,1,70,1,70,1,70,1,70,
        1,70,1,70,1,71,1,71,1,71,1,71,1,71,1,71,1,71,1,71,1,71,1,71,1,71,
        1,71,1,71,1,71,1,71,1,71,1,71,1,71,1,71,1,71,1,71,1,71,1,71,1,71,
        1,71,1,72,1,72,1,72,1,72,1,72,1,72,1,72,1,72,1,72,1,72,1,72,1,72,
        1,72,1,72,1,72,1,72,1,72,1,72,1,72,1,72,1,72,1,72,1,72,1,72,1,72,
        1,72,1,72,1,72,1,72,1,72,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,
        1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,
        1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,74,1,74,
        1,74,1,74,1,74,1,74,1,74,1,74,1,74,1,74,1,74,1,74,1,74,1,74,1,74,
        1,74,1,74,1,74,1,74,1,74,1,74,1,74,1,74,1,74,1,74,1,74,1,74,1,74,
        1,74,1,74,1,74,1,74,1,75,1,75,1,75,1,75,1,75,1,75,1,75,1,75,1,75,
        1,75,1,75,1,75,1,75,1,76,1,76,1,76,1,76,1,76,1,76,1,76,1,76,1,76,
        1,76,1,76,1,76,1,76,1,76,1,76,1,77,1,77,1,77,1,77,1,77,1,77,1,77,
        1,77,1,77,1,77,1,77,1,77,1,77,1,77,1,77,1,78,1,78,1,78,1,78,1,78,
        1,78,1,78,1,78,1,78,1,78,1,78,1,78,1,78,1,78,1,79,1,79,1,79,1,79,
        5,79,1122,8,79,10,79,12,79,1125,9,79,1,79,1,79,1,80,4,80,1130,8,
        80,11,80,12,80,1131,1,81,1,81,1,81,1,81,3,81,1138,8,81,1,82,1,82,
        1,82,1,82,1,82,1,82,3,82,1146,8,82,1,83,1,83,1,83,1,83,1,83,1,84,
        1,84,1,84,1,84,1,84,1,84,1,85,1,85,1,86,1,86,1,87,1,87,1,88,1,88,
        1,89,1,89,1,89,1,89,4,89,1171,8,89,11,89,12,89,1172,1,89,1,89,1,
        90,1,90,1,91,1,91,3,91,1181,8,91,1,92,1,92,1,93,1,93,1,94,1,94,1,
        95,1,95,1,96,1,96,1,97,1,97,1,98,1,98,1,99,1,99,1,99,1,99,1,99,1,
        99,1,99,1,99,1,99,1,100,1,100,1,100,1,101,1,101,1,101,1,102,1,102,
        1,102,1,103,1,103,1,104,1,104,1,105,1,105,1,105,1,105,1,106,1,106,
        1,106,1,106,1,107,1,107,1,107,1,107,1,108,1,108,1,108,1,108,1,108,
        1,108,1,109,1,109,1,109,1,109,1,109,1,109,1,110,1,110,1,110,1,110,
        1,110,1,110,1,110,1,110,1,110,1,111,1,111,1,111,1,112,1,112,1,112,
        1,112,1,113,1,113,1,113,1,114,1,114,1,114,1,114,1,115,1,115,1,115,
        1,115,1,115,1,115,1,115,1,115,1,115,1,115,1,115,1,116,1,116,1,116,
        1,116,1,116,1,116,1,117,1,117,1,117,1,117,1,117,1,117,1,117,1,117,
        1,117,1,117,1,117,1,117,1,117,1,118,1,118,1,118,1,118,1,118,1,118,
        1,118,1,118,1,118,1,118,1,118,1,119,1,119,1,119,1,119,1,119,1,119,
        1,120,1,120,1,121,1,121,1,121,1,121,1,121,1,122,1,122,1,122,1,122,
        1,122,1,122,1,123,1,123,1,123,1,123,1,123,1,123,1,123,1,124,1,124,
        1,124,1,124,1,124,1,124,1,125,1,125,1,125,1,125,1,125,1,125,1,125,
        1,125,1,125,1,125,1,125,1,125,1,125,1,125,1,125,1,125,1,126,1,126,
        1,126,1,126,1,126,1,126,1,126,1,126,1,126,1,126,1,126,1,126,1,126,
        1,126,1,126,1,126,1,127,1,127,1,127,1,127,1,127,1,127,1,127,1,127,
        1,127,1,127,1,127,1,127,1,127,1,127,1,128,1,128,1,128,1,128,1,128,
        1,128,1,128,1,128,1,128,1,128,1,128,1,128,1,128,1,129,1,129,1,129,
        1,129,1,129,1,129,1,129,1,129,1,129,1,129,1,129,1,129,1,129,1,129,
        1,129,1,130,1,130,1,131,4,131,1416,8,131,11,131,12,131,1417,1,131,
        1,131,1,132,1,132,1,132,1,132,1,132,1,132,1,132,1,132,1,132,1,132,
        1,133,1,133,1,133,1,133,1,133,1,133,1,133,1,133,1,133,1,133,1,133,
        1,133,1,133,1,133,1,133,1,133,1,133,1,133,1,133,1,133,1,133,1,134,
        1,134,1,134,1,134,1,134,1,134,1,134,1,134,1,134,1,134,1,134,1,134,
        1,134,1,134,1,135,1,135,1,135,1,135,1,135,1,135,1,135,1,135,1,135,
        1,135,1,135,1,135,1,136,1,136,1,136,1,136,1,136,1,136,1,136,1,136,
        1,136,1,136,1,136,1,136,1,137,1,137,1,137,1,137,1,137,1,137,1,137,
        1,138,1,138,1,138,1,138,1,138,1,138,1,138,1,138,1,138,1,138,1,138,
        1,138,1,138,1,138,1,138,1,138,1,138,1,138,1,138,1,138,1,138,1,139,
        1,139,1,139,1,139,1,139,1,139,1,139,1,139,1,139,1,140,1,140,1,140,
        1,140,1,140,1,140,1,140,1,140,1,140,1,140,1,140,1,140,1,140,1,140,
        1,140,1,140,1,140,1,141,1,141,1,141,1,141,1,141,1,141,1,141,1,141,
        1,141,1,141,1,141,1,141,1,141,1,141,1,141,1,141,1,141,1,141,1,141,
        1,141,1,142,1,142,1,142,1,142,1,142,1,142,1,142,1,142,1,142,1,142,
        1,142,1,142,1,142,1,142,1,142,1,142,1,142,1,142,1,142,1,142,1,142,
        1,142,1,142,1,142,1,142,1,142,1,142,1,142,1,142,1,142,1,142,1,143,
        1,143,1,143,1,143,1,143,1,143,1,143,1,143,1,143,1,143,1,143,1,143,
        1,143,1,143,1,143,1,143,1,143,1,143,1,143,1,143,1,143,1,143,1,143,
        1,143,1,144,1,144,1,144,1,144,1,144,1,144,1,144,1,144,1,144,1,144,
        1,144,1,144,1,144,1,144,1,144,1,144,1,144,1,144,1,144,1,144,1,144,
        1,144,1,145,1,145,1,145,1,145,1,145,1,145,1,145,1,145,1,145,1,145,
        1,145,1,145,1,145,1,145,1,145,1,145,1,145,1,145,1,145,1,145,1,145,
        1,145,1,146,1,146,1,146,1,146,1,146,1,146,1,146,1,146,1,146,1,146,
        1,146,1,146,1,146,1,146,1,146,1,146,1,146,1,147,1,147,1,147,1,147,
        1,147,1,147,1,147,1,147,1,147,1,147,1,147,1,147,1,147,1,147,1,147,
        1,147,1,147,1,147,1,147,1,147,1,147,1,147,1,147,1,147,1,147,1,147,
        1,147,1,147,1,147,1,147,1,147,1,148,1,148,1,148,1,148,1,148,1,148,
        1,148,1,148,1,148,1,148,1,148,1,148,1,148,1,148,1,148,1,148,1,148,
        1,148,1,148,1,149,1,149,1,149,1,149,1,149,1,149,1,149,1,149,1,149,
        1,149,1,149,1,149,1,149,1,149,1,149,1,149,1,149,1,149,1,149,1,149,
        1,149,1,149,1,149,1,149,1,149,1,149,1,149,1,150,1,150,1,150,1,150,
        1,150,1,150,1,150,1,150,1,150,1,150,1,150,1,150,1,150,1,150,1,150,
        1,150,1,150,1,150,1,150,1,150,1,150,1,150,1,150,1,150,1,150,1,150,
        1,150,1,151,1,151,1,151,1,151,1,151,1,151,1,151,1,151,1,151,1,151,
        1,151,1,151,1,151,1,151,1,151,1,151,1,151,1,151,1,151,1,151,1,151,
        1,151,1,151,1,151,1,151,1,151,1,151,1,151,1,151,1,151,1,151,1,151,
        1,151,1,151,1,151,1,151,1,151,1,151,1,152,1,152,1,152,1,152,1,152,
        1,152,1,152,1,152,1,152,1,152,1,152,1,152,1,152,1,152,1,152,1,152,
        1,152,1,152,1,152,1,152,1,152,1,152,1,152,1,152,1,152,1,152,1,152,
        1,152,1,152,1,152,1,152,1,153,1,153,1,153,1,153,1,153,1,153,1,153,
        1,153,1,153,1,153,1,153,1,153,1,153,1,153,1,153,1,153,1,153,1,153,
        1,153,1,153,1,153,1,153,1,153,1,153,1,153,1,153,1,153,1,153,1,153,
        1,154,1,154,1,154,1,154,1,154,1,154,1,154,1,154,1,154,1,154,1,154,
        1,154,1,154,1,154,1,154,1,154,1,154,1,154,1,154,1,154,1,154,1,154,
        1,154,1,154,1,154,1,154,1,154,1,154,1,154,1,155,1,155,1,155,1,155,
        1,155,1,155,1,155,1,155,1,155,1,155,1,155,1,155,1,155,1,155,1,155,
        1,155,1,155,1,155,1,155,1,155,1,155,1,155,1,155,1,155,1,156,1,156,
        1,156,1,156,1,156,1,156,1,156,1,156,1,156,1,156,1,156,1,156,1,156,
        1,156,1,156,1,156,1,156,1,156,1,156,1,156,1,156,1,156,1,156,1,156,
        1,156,1,156,1,156,1,156,1,156,1,156,1,156,1,156,1,156,1,156,1,156,
        1,156,1,156,1,156,1,157,1,157,1,157,1,157,1,157,1,157,1,157,1,157,
        1,157,1,157,1,157,1,157,1,157,1,157,1,157,1,157,1,157,1,157,1,157,
        1,157,1,157,1,157,1,157,1,157,1,157,1,157,1,158,1,158,1,158,1,158,
        1,158,1,158,1,158,1,158,1,158,1,158,1,158,1,158,1,158,1,158,1,158,
        1,158,1,158,1,158,1,158,1,158,1,158,1,158,1,158,1,158,1,158,1,158,
        1,158,1,158,1,158,1,158,1,158,1,158,1,158,1,158,1,159,1,159,1,159,
        1,159,1,159,1,159,1,159,1,159,1,159,1,159,1,159,1,159,1,159,1,159,
        1,159,1,159,1,159,1,159,1,159,1,159,1,159,1,159,1,159,1,159,1,159,
        1,159,1,159,1,159,1,159,1,159,1,159,1,159,1,159,1,159,1,159,1,159,
        1,159,1,159,3,159,2072,8,159,1,160,1,160,1,160,1,160,1,160,1,160,
        1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,
        1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,
        1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,
        1,160,1,160,1,160,1,160,1,160,1,160,1,160,3,160,2120,8,160,1,161,
        1,161,1,161,1,161,1,161,1,161,1,161,1,161,1,161,1,161,1,161,1,161,
        1,161,1,161,1,161,1,161,1,161,1,162,1,162,1,162,1,162,1,162,1,162,
        1,162,1,162,1,162,1,162,1,162,1,162,1,162,1,162,1,162,1,162,1,162,
        1,163,1,163,1,163,1,163,1,163,1,163,1,163,1,163,1,163,1,163,1,163,
        1,163,1,163,1,163,1,163,1,164,1,164,1,164,1,164,1,164,1,164,1,164,
        1,164,1,164,1,164,1,164,1,164,1,164,1,164,1,164,1,164,1,164,1,164,
        1,164,1,164,1,164,1,164,1,164,1,164,1,164,1,164,1,164,1,164,1,164,
        1,164,3,164,2201,8,164,1,165,1,165,1,165,1,165,1,165,1,165,1,165,
        1,165,1,165,1,165,1,165,1,165,1,165,1,165,1,165,1,166,1,166,1,166,
        1,166,1,166,1,166,1,166,1,166,1,166,1,166,1,166,1,166,1,166,1,166,
        1,166,1,166,1,166,1,166,3,166,2236,8,166,1,167,1,167,1,167,1,167,
        1,167,1,167,1,167,1,167,1,167,1,167,1,167,1,167,1,167,1,167,1,167,
        1,167,1,167,1,167,1,167,3,167,2257,8,167,1,168,1,168,1,168,1,168,
        1,168,1,168,1,168,1,168,1,168,1,168,1,168,1,168,1,168,1,168,1,168,
        1,168,1,168,1,168,1,168,1,168,1,168,1,168,1,168,1,168,1,168,1,168,
        1,168,1,168,1,168,1,168,1,168,1,168,1,168,1,168,1,168,1,168,1,168,
        1,168,1,168,1,168,1,168,1,168,1,168,1,168,1,168,1,168,1,168,1,168,
        1,168,1,168,1,168,3,168,2310,8,168,1,169,1,169,1,169,1,169,1,169,
        1,169,1,169,1,169,1,169,1,169,1,169,1,169,1,169,1,169,1,169,1,169,
        1,170,1,170,1,170,1,170,1,170,1,170,1,170,1,170,1,170,1,171,1,171,
        1,171,1,171,1,171,1,171,1,171,1,171,1,171,1,171,1,171,1,171,1,171,
        1,171,1,171,1,171,1,171,1,171,1,171,1,171,1,171,1,171,1,171,1,171,
        1,171,1,171,1,171,1,171,1,171,1,171,1,171,1,171,1,171,1,171,1,171,
        1,171,1,171,1,171,1,171,1,171,1,171,1,171,1,171,1,171,1,171,1,171,
        1,171,1,171,1,171,1,171,1,171,1,171,1,171,1,171,1,171,1,171,1,171,
        1,171,1,171,1,171,1,171,1,171,1,171,1,171,1,171,1,171,1,171,1,171,
        1,171,1,171,1,171,1,171,1,171,1,171,1,171,1,171,1,171,1,171,1,171,
        1,171,1,171,1,171,1,171,1,171,1,171,1,171,1,171,3,171,2424,8,171,
        1,172,1,172,1,172,1,172,1,172,1,172,1,172,1,172,1,172,1,172,1,172,
        1,172,1,172,1,172,1,172,1,172,1,172,1,172,1,172,1,172,1,172,1,172,
        1,172,1,172,1,172,1,172,1,172,1,172,1,172,1,172,1,172,1,172,1,172,
        1,172,1,172,1,172,1,172,1,172,1,172,1,172,1,172,1,172,1,172,1,172,
        1,172,1,172,1,172,1,172,1,172,1,172,1,172,1,172,1,172,1,172,1,172,
        1,172,1,172,1,172,1,172,1,172,1,172,3,172,2487,8,172,1,173,1,173,
        1,173,1,173,1,173,1,173,1,173,1,173,1,173,1,173,1,173,1,173,1,173,
        1,173,1,173,1,173,1,173,1,173,1,173,1,173,1,173,1,173,1,173,1,173,
        1,173,1,173,1,173,1,173,1,173,1,173,1,173,1,173,1,173,1,173,1,173,
        1,173,1,173,1,173,1,173,1,173,1,173,1,173,1,173,1,173,1,173,1,173,
        1,173,1,173,1,173,1,173,1,173,1,173,1,173,1,173,1,173,1,173,1,173,
        1,173,1,173,1,173,1,173,1,173,1,173,1,173,1,173,1,173,1,173,1,173,
        1,173,1,173,1,173,1,173,1,173,1,173,1,173,1,173,1,173,1,173,1,173,
        1,173,1,173,1,173,1,173,1,173,1,173,1,173,1,173,1,173,3,173,2577,
        8,173,1,174,1,174,1,174,1,174,1,174,1,174,1,174,1,174,1,174,1,174,
        1,174,1,174,1,174,1,174,1,174,1,174,1,174,1,174,1,174,1,174,1,174,
        1,174,1,174,1,174,1,174,1,174,1,174,1,174,1,174,1,174,1,174,1,174,
        1,174,1,174,1,174,1,174,1,174,1,174,1,174,1,174,1,174,1,174,1,174,
        3,174,2622,8,174,1,175,1,175,1,175,1,175,1,175,1,175,1,175,1,175,
        1,175,1,175,1,175,1,175,1,175,1,175,1,175,1,175,1,175,1,175,1,175,
        1,175,1,175,1,175,1,175,1,175,1,175,1,175,1,175,1,175,1,175,1,175,
        1,175,1,175,1,175,1,175,1,175,1,175,1,175,1,175,1,175,1,175,1,175,
        1,175,1,175,3,175,2667,8,175,1,176,1,176,1,176,1,176,1,176,1,176,
        1,176,1,176,1,176,1,176,1,176,1,176,1,176,1,176,1,176,1,176,1,176,
        1,176,1,176,1,176,1,176,1,176,1,176,1,176,1,176,1,176,1,176,1,176,
        1,176,1,176,1,176,1,176,1,176,1,176,1,176,1,176,1,176,1,176,1,176,
        1,176,1,176,1,176,1,176,1,176,1,176,1,176,1,176,1,176,1,176,1,176,
        1,176,1,176,1,176,1,176,1,176,3,176,2724,8,176,1,177,1,177,1,177,
        1,177,1,177,1,177,1,177,1,177,1,177,1,177,1,177,1,177,1,177,1,177,
        1,177,1,177,1,177,1,177,1,178,1,178,1,178,1,178,1,178,1,178,1,178,
        1,178,1,178,1,178,1,178,1,178,1,178,1,178,1,178,1,178,1,178,1,178,
        1,178,1,178,1,178,1,178,1,178,1,178,1,178,1,178,1,178,1,178,1,178,
        1,178,1,178,1,178,1,178,1,178,1,178,1,178,1,178,1,178,1,178,1,178,
        1,178,1,178,1,178,1,178,1,178,1,178,1,178,1,178,1,178,1,178,1,178,
        3,178,2795,8,178,1,179,1,179,1,179,1,179,1,179,1,179,1,179,1,179,
        1,179,1,179,1,179,1,179,1,179,1,179,1,179,1,179,1,179,1,179,1,179,
        1,179,1,179,1,179,1,179,1,179,1,179,1,179,1,179,1,179,3,179,2825,
        8,179,1,180,1,180,1,180,1,180,1,180,1,180,1,180,1,180,1,180,1,180,
        1,180,1,180,1,180,1,180,1,180,1,180,1,180,1,180,1,180,1,180,1,180,
        1,180,1,180,1,180,1,180,1,181,1,181,1,181,1,181,1,181,1,181,1,181,
        1,181,1,181,1,181,1,181,1,181,1,181,1,181,1,181,1,181,1,182,1,182,
        1,182,1,182,1,182,1,182,1,182,1,182,1,182,1,182,1,182,1,182,1,182,
        1,182,1,182,1,182,1,182,1,182,1,182,1,182,1,183,1,183,1,183,1,183,
        1,183,1,183,1,183,1,183,1,183,1,183,1,183,1,183,1,183,1,183,1,183,
        1,183,1,183,1,183,1,183,1,183,1,183,1,183,1,183,1,183,1,183,1,183,
        1,183,1,183,1,183,1,183,1,183,1,183,1,183,1,183,1,183,1,183,1,183,
        1,183,1,183,1,183,1,183,1,183,1,183,1,183,1,183,1,183,1,183,1,183,
        1,183,1,183,1,183,1,183,1,183,1,183,1,183,1,183,1,183,1,183,1,183,
        1,183,1,183,1,183,1,183,1,183,1,183,3,183,2953,8,183,1,184,1,184,
        1,184,1,184,1,184,1,184,1,184,1,184,1,184,1,184,1,184,1,184,1,184,
        1,184,1,184,1,184,1,184,1,184,1,184,1,184,1,184,1,184,1,184,1,184,
        1,184,1,184,1,184,1,184,1,184,1,184,1,184,1,184,1,184,1,184,1,184,
        1,184,1,184,1,184,1,184,1,184,1,184,1,184,1,184,1,184,1,184,1,184,
        1,184,1,184,1,184,1,184,1,184,1,184,1,184,1,184,1,184,1,184,1,184,
        1,184,1,184,1,184,1,184,1,184,1,184,1,184,1,184,1,184,1,184,1,184,
        1,184,1,184,1,184,1,184,1,184,1,184,1,184,1,184,1,184,1,184,1,184,
        1,184,1,184,1,184,1,184,3,184,3038,8,184,1,185,1,185,1,185,1,185,
        1,185,1,185,1,185,1,185,1,185,1,185,1,185,1,185,1,185,1,185,1,185,
        1,185,1,185,1,185,1,185,1,185,1,185,1,185,1,185,1,185,1,185,1,185,
        1,185,1,185,1,185,1,185,1,185,1,185,1,185,1,185,1,185,1,185,1,185,
        1,185,1,185,1,185,1,185,1,185,1,185,1,185,1,185,1,185,1,185,1,185,
        1,185,1,185,1,185,1,185,1,185,1,185,1,185,1,185,1,185,1,185,1,185,
        1,185,1,185,1,185,1,185,1,185,1,185,1,185,1,185,1,185,1,185,1,185,
        1,185,1,185,1,185,1,185,1,185,1,185,1,185,1,185,1,185,1,185,1,185,
        1,185,1,185,1,185,1,185,1,185,1,185,1,185,1,185,1,185,1,185,1,185,
        1,185,1,185,1,185,3,185,3135,8,185,1,186,1,186,1,186,1,186,1,186,
        1,186,1,186,1,186,1,186,1,186,1,186,1,186,1,186,1,186,1,186,1,186,
        1,186,1,186,1,186,1,186,1,186,1,186,1,186,1,186,1,186,1,186,1,186,
        1,186,1,186,1,186,1,186,1,186,1,186,1,186,1,186,1,186,1,186,1,186,
        1,186,1,186,1,186,1,186,1,186,1,186,1,186,1,186,1,186,1,186,1,186,
        1,186,1,186,1,186,1,186,1,186,1,186,1,186,1,186,1,186,1,186,1,186,
        1,186,1,186,1,186,1,186,1,186,1,186,1,186,1,186,1,186,1,186,1,186,
        1,186,1,186,1,186,1,186,3,186,3212,8,186,1,187,1,187,1,188,1,188,
        1,188,1,188,1,188,1,188,1,188,1,188,1,188,1,188,1,188,1,188,1,188,
        1,188,1,188,1,188,1,188,1,188,1,188,1,188,1,188,1,188,1,188,1,188,
        1,188,1,188,1,188,1,188,1,188,1,188,1,188,1,188,1,188,1,188,1,188,
        1,188,1,188,1,188,1,188,1,188,1,188,1,188,1,188,1,188,1,188,1,188,
        1,188,1,188,1,188,1,188,1,188,1,188,1,188,1,188,1,188,1,188,1,188,
        1,188,1,188,3,188,3275,8,188,1,189,1,189,1,189,1,189,1,189,1,189,
        1,189,1,189,1,189,1,189,1,189,1,189,1,189,1,189,1,189,1,189,1,189,
        1,189,1,189,1,189,1,189,1,189,1,189,1,189,1,189,1,189,1,189,1,189,
        1,189,1,189,1,189,1,189,1,189,1,189,1,189,1,189,1,189,1,189,1,189,
        1,189,1,189,1,189,1,189,3,189,3320,8,189,1,190,1,190,1,190,1,190,
        1,190,1,190,1,190,1,190,1,190,1,190,1,190,1,190,1,190,1,190,1,190,
        1,190,1,190,1,190,1,190,1,190,1,190,1,190,1,190,1,190,1,190,1,190,
        1,190,1,190,1,190,1,190,1,190,1,190,1,190,1,190,1,190,1,190,1,190,
        1,190,1,190,1,190,1,190,1,190,1,190,1,190,1,190,1,190,1,190,1,190,
        1,190,1,190,1,190,1,190,1,190,1,190,1,190,1,190,1,190,1,190,1,190,
        1,190,1,190,1,190,1,190,3,190,3385,8,190,1,191,1,191,1,191,1,191,
        1,191,1,191,1,191,1,191,1,191,1,191,1,191,1,191,1,191,1,191,1,191,
        1,191,1,191,1,191,1,191,1,191,1,191,1,191,1,191,1,191,1,191,1,191,
        1,191,1,191,1,191,1,191,1,191,1,191,1,191,1,191,1,191,1,191,1,191,
        1,191,1,191,1,191,1,191,1,191,1,191,1,191,1,191,1,191,1,191,1,191,
        1,191,1,191,1,191,1,191,1,191,1,191,1,191,1,191,1,191,1,191,1,191,
        1,191,1,191,1,191,1,191,1,191,1,191,1,191,1,191,1,191,1,191,1,191,
        3,191,3457,8,191,0,0,192,1,1,3,2,5,3,7,4,9,5,11,6,13,7,15,8,17,9,
        19,10,21,11,23,12,25,13,27,14,29,15,31,16,33,17,35,18,37,19,39,20,
        41,21,43,22,45,23,47,24,49,25,51,26,53,27,55,28,57,29,59,30,61,31,
        63,32,65,33,67,34,69,35,71,36,73,37,75,38,77,39,79,40,81,41,83,42,
        85,43,87,44,89,45,91,46,93,47,95,48,97,49,99,50,101,51,103,52,105,
        53,107,54,109,55,111,56,113,57,115,58,117,59,119,60,121,61,123,62,
        125,63,127,64,129,65,131,66,133,67,135,68,137,69,139,70,141,71,143,
        72,145,73,147,74,149,75,151,76,153,77,155,78,157,79,159,80,161,81,
        163,82,165,83,167,84,169,85,171,86,173,87,175,88,177,89,179,0,181,
        0,183,0,185,0,187,0,189,90,191,91,193,92,195,93,197,94,199,95,201,
        96,203,97,205,98,207,99,209,100,211,101,213,102,215,103,217,104,
        219,105,221,106,223,107,225,108,227,109,229,110,231,111,233,112,
        235,113,237,114,239,115,241,116,243,117,245,118,247,119,249,120,
        251,121,253,122,255,123,257,124,259,125,261,126,263,127,265,128,
        267,129,269,130,271,131,273,132,275,133,277,134,279,135,281,136,
        283,137,285,138,287,139,289,140,291,141,293,142,295,143,297,144,
        299,145,301,146,303,147,305,148,307,149,309,150,311,151,313,152,
        315,153,317,154,319,155,321,156,323,157,325,158,327,159,329,160,
        331,161,333,162,335,163,337,164,339,165,341,166,343,167,345,168,
        347,169,349,170,351,171,353,172,355,173,357,174,359,175,361,176,
        363,177,365,178,367,179,369,180,371,181,373,182,375,183,377,184,
        379,185,381,186,383,187,1,0,15,4,0,46,46,48,57,65,90,97,122,4,0,
        45,45,48,57,65,90,97,122,2,0,10,10,13,13,1,0,48,57,1,0,48,48,1,0,
        49,57,1,0,49,49,1,0,48,50,2,0,44,44,49,50,1,0,51,51,2,0,44,44,48,
        49,2,0,65,90,97,122,2,0,45,46,95,95,8,0,32,33,35,44,46,47,58,64,
        91,94,96,96,123,126,8217,8217,3,0,9,10,13,13,32,32,3522,0,1,1,0,
        0,0,0,3,1,0,0,0,0,5,1,0,0,0,0,7,1,0,0,0,0,9,1,0,0,0,0,11,1,0,0,0,
        0,13,1,0,0,0,0,15,1,0,0,0,0,17,1,0,0,0,0,19,1,0,0,0,0,21,1,0,0,0,
        0,23,1,0,0,0,0,25,1,0,0,0,0,27,1,0,0,0,0,29,1,0,0,0,0,31,1,0,0,0,
        0,33,1,0,0,0,0,35,1,0,0,0,0,37,1,0,0,0,0,39,1,0,0,0,0,41,1,0,0,0,
        0,43,1,0,0,0,0,45,1,0,0,0,0,47,1,0,0,0,0,49,1,0,0,0,0,51,1,0,0,0,
        0,53,1,0,0,0,0,55,1,0,0,0,0,57,1,0,0,0,0,59,1,0,0,0,0,61,1,0,0,0,
        0,63,1,0,0,0,0,65,1,0,0,0,0,67,1,0,0,0,0,69,1,0,0,0,0,71,1,0,0,0,
        0,73,1,0,0,0,0,75,1,0,0,0,0,77,1,0,0,0,0,79,1,0,0,0,0,81,1,0,0,0,
        0,83,1,0,0,0,0,85,1,0,0,0,0,87,1,0,0,0,0,89,1,0,0,0,0,91,1,0,0,0,
        0,93,1,0,0,0,0,95,1,0,0,0,0,97,1,0,0,0,0,99,1,0,0,0,0,101,1,0,0,
        0,0,103,1,0,0,0,0,105,1,0,0,0,0,107,1,0,0,0,0,109,1,0,0,0,0,111,
        1,0,0,0,0,113,1,0,0,0,0,115,1,0,0,0,0,117,1,0,0,0,0,119,1,0,0,0,
        0,121,1,0,0,0,0,123,1,0,0,0,0,125,1,0,0,0,0,127,1,0,0,0,0,129,1,
        0,0,0,0,131,1,0,0,0,0,133,1,0,0,0,0,135,1,0,0,0,0,137,1,0,0,0,0,
        139,1,0,0,0,0,141,1,0,0,0,0,143,1,0,0,0,0,145,1,0,0,0,0,147,1,0,
        0,0,0,149,1,0,0,0,0,151,1,0,0,0,0,153,1,0,0,0,0,155,1,0,0,0,0,157,
        1,0,0,0,0,159,1,0,0,0,0,161,1,0,0,0,0,163,1,0,0,0,0,165,1,0,0,0,
        0,167,1,0,0,0,0,169,1,0,0,0,0,171,1,0,0,0,0,173,1,0,0,0,0,175,1,
        0,0,0,0,177,1,0,0,0,0,189,1,0,0,0,0,191,1,0,0,0,0,193,1,0,0,0,0,
        195,1,0,0,0,0,197,1,0,0,0,0,199,1,0,0,0,0,201,1,0,0,0,0,203,1,0,
        0,0,0,205,1,0,0,0,0,207,1,0,0,0,0,209,1,0,0,0,0,211,1,0,0,0,0,213,
        1,0,0,0,0,215,1,0,0,0,0,217,1,0,0,0,0,219,1,0,0,0,0,221,1,0,0,0,
        0,223,1,0,0,0,0,225,1,0,0,0,0,227,1,0,0,0,0,229,1,0,0,0,0,231,1,
        0,0,0,0,233,1,0,0,0,0,235,1,0,0,0,0,237,1,0,0,0,0,239,1,0,0,0,0,
        241,1,0,0,0,0,243,1,0,0,0,0,245,1,0,0,0,0,247,1,0,0,0,0,249,1,0,
        0,0,0,251,1,0,0,0,0,253,1,0,0,0,0,255,1,0,0,0,0,257,1,0,0,0,0,259,
        1,0,0,0,0,261,1,0,0,0,0,263,1,0,0,0,0,265,1,0,0,0,0,267,1,0,0,0,
        0,269,1,0,0,0,0,271,1,0,0,0,0,273,1,0,0,0,0,275,1,0,0,0,0,277,1,
        0,0,0,0,279,1,0,0,0,0,281,1,0,0,0,0,283,1,0,0,0,0,285,1,0,0,0,0,
        287,1,0,0,0,0,289,1,0,0,0,0,291,1,0,0,0,0,293,1,0,0,0,0,295,1,0,
        0,0,0,297,1,0,0,0,0,299,1,0,0,0,0,301,1,0,0,0,0,303,1,0,0,0,0,305,
        1,0,0,0,0,307,1,0,0,0,0,309,1,0,0,0,0,311,1,0,0,0,0,313,1,0,0,0,
        0,315,1,0,0,0,0,317,1,0,0,0,0,319,1,0,0,0,0,321,1,0,0,0,0,323,1,
        0,0,0,0,325,1,0,0,0,0,327,1,0,0,0,0,329,1,0,0,0,0,331,1,0,0,0,0,
        333,1,0,0,0,0,335,1,0,0,0,0,337,1,0,0,0,0,339,1,0,0,0,0,341,1,0,
        0,0,0,343,1,0,0,0,0,345,1,0,0,0,0,347,1,0,0,0,0,349,1,0,0,0,0,351,
        1,0,0,0,0,353,1,0,0,0,0,355,1,0,0,0,0,357,1,0,0,0,0,359,1,0,0,0,
        0,361,1,0,0,0,0,363,1,0,0,0,0,365,1,0,0,0,0,367,1,0,0,0,0,369,1,
        0,0,0,0,371,1,0,0,0,0,373,1,0,0,0,0,375,1,0,0,0,0,377,1,0,0,0,0,
        379,1,0,0,0,0,381,1,0,0,0,0,383,1,0,0,0,1,385,1,0,0,0,3,393,1,0,
        0,0,5,401,1,0,0,0,7,414,1,0,0,0,9,423,1,0,0,0,11,433,1,0,0,0,13,
        444,1,0,0,0,15,450,1,0,0,0,17,464,1,0,0,0,19,481,1,0,0,0,21,498,
        1,0,0,0,23,517,1,0,0,0,25,529,1,0,0,0,27,539,1,0,0,0,29,555,1,0,
        0,0,31,557,1,0,0,0,33,560,1,0,0,0,35,580,1,0,0,0,37,591,1,0,0,0,
        39,593,1,0,0,0,41,608,1,0,0,0,43,613,1,0,0,0,45,615,1,0,0,0,47,630,
        1,0,0,0,49,635,1,0,0,0,51,637,1,0,0,0,53,651,1,0,0,0,55,656,1,0,
        0,0,57,658,1,0,0,0,59,676,1,0,0,0,61,681,1,0,0,0,63,683,1,0,0,0,
        65,705,1,0,0,0,67,708,1,0,0,0,69,712,1,0,0,0,71,716,1,0,0,0,73,720,
        1,0,0,0,75,724,1,0,0,0,77,728,1,0,0,0,79,732,1,0,0,0,81,736,1,0,
        0,0,83,740,1,0,0,0,85,747,1,0,0,0,87,752,1,0,0,0,89,756,1,0,0,0,
        91,760,1,0,0,0,93,764,1,0,0,0,95,768,1,0,0,0,97,772,1,0,0,0,99,776,
        1,0,0,0,101,780,1,0,0,0,103,787,1,0,0,0,105,792,1,0,0,0,107,809,
        1,0,0,0,109,813,1,0,0,0,111,817,1,0,0,0,113,821,1,0,0,0,115,825,
        1,0,0,0,117,829,1,0,0,0,119,833,1,0,0,0,121,837,1,0,0,0,123,841,
        1,0,0,0,125,845,1,0,0,0,127,849,1,0,0,0,129,853,1,0,0,0,131,857,
        1,0,0,0,133,861,1,0,0,0,135,864,1,0,0,0,137,883,1,0,0,0,139,893,
        1,0,0,0,141,916,1,0,0,0,143,941,1,0,0,0,145,966,1,0,0,0,147,996,
        1,0,0,0,149,1028,1,0,0,0,151,1060,1,0,0,0,153,1073,1,0,0,0,155,1088,
        1,0,0,0,157,1103,1,0,0,0,159,1117,1,0,0,0,161,1129,1,0,0,0,163,1137,
        1,0,0,0,165,1145,1,0,0,0,167,1147,1,0,0,0,169,1152,1,0,0,0,171,1158,
        1,0,0,0,173,1160,1,0,0,0,175,1162,1,0,0,0,177,1164,1,0,0,0,179,1166,
        1,0,0,0,181,1176,1,0,0,0,183,1180,1,0,0,0,185,1182,1,0,0,0,187,1184,
        1,0,0,0,189,1186,1,0,0,0,191,1188,1,0,0,0,193,1190,1,0,0,0,195,1192,
        1,0,0,0,197,1194,1,0,0,0,199,1196,1,0,0,0,201,1205,1,0,0,0,203,1208,
        1,0,0,0,205,1211,1,0,0,0,207,1214,1,0,0,0,209,1216,1,0,0,0,211,1218,
        1,0,0,0,213,1222,1,0,0,0,215,1226,1,0,0,0,217,1230,1,0,0,0,219,1236,
        1,0,0,0,221,1242,1,0,0,0,223,1251,1,0,0,0,225,1254,1,0,0,0,227,1258,
        1,0,0,0,229,1261,1,0,0,0,231,1265,1,0,0,0,233,1276,1,0,0,0,235,1282,
        1,0,0,0,237,1295,1,0,0,0,239,1306,1,0,0,0,241,1312,1,0,0,0,243,1314,
        1,0,0,0,245,1319,1,0,0,0,247,1325,1,0,0,0,249,1332,1,0,0,0,251,1338,
        1,0,0,0,253,1354,1,0,0,0,255,1370,1,0,0,0,257,1384,1,0,0,0,259,1397,
        1,0,0,0,261,1412,1,0,0,0,263,1415,1,0,0,0,265,1421,1,0,0,0,267,1431,
        1,0,0,0,269,1452,1,0,0,0,271,1466,1,0,0,0,273,1478,1,0,0,0,275,1490,
        1,0,0,0,277,1497,1,0,0,0,279,1518,1,0,0,0,281,1527,1,0,0,0,283,1544,
        1,0,0,0,285,1564,1,0,0,0,287,1595,1,0,0,0,289,1619,1,0,0,0,291,1641,
        1,0,0,0,293,1663,1,0,0,0,295,1680,1,0,0,0,297,1711,1,0,0,0,299,1730,
        1,0,0,0,301,1757,1,0,0,0,303,1784,1,0,0,0,305,1822,1,0,0,0,307,1853,
        1,0,0,0,309,1882,1,0,0,0,311,1911,1,0,0,0,313,1935,1,0,0,0,315,1973,
        1,0,0,0,317,1999,1,0,0,0,319,2071,1,0,0,0,321,2119,1,0,0,0,323,2121,
        1,0,0,0,325,2138,1,0,0,0,327,2155,1,0,0,0,329,2200,1,0,0,0,331,2202,
        1,0,0,0,333,2235,1,0,0,0,335,2256,1,0,0,0,337,2309,1,0,0,0,339,2311,
        1,0,0,0,341,2327,1,0,0,0,343,2423,1,0,0,0,345,2486,1,0,0,0,347,2576,
        1,0,0,0,349,2621,1,0,0,0,351,2666,1,0,0,0,353,2723,1,0,0,0,355,2725,
        1,0,0,0,357,2794,1,0,0,0,359,2824,1,0,0,0,361,2826,1,0,0,0,363,2851,
        1,0,0,0,365,2867,1,0,0,0,367,2952,1,0,0,0,369,3037,1,0,0,0,371,3134,
        1,0,0,0,373,3211,1,0,0,0,375,3213,1,0,0,0,377,3274,1,0,0,0,379,3319,
        1,0,0,0,381,3384,1,0,0,0,383,3456,1,0,0,0,385,386,5,73,0,0,386,387,
        5,78,0,0,387,388,5,67,0,0,388,389,5,76,0,0,389,390,5,85,0,0,390,
        391,5,68,0,0,391,392,5,69,0,0,392,2,1,0,0,0,393,394,5,69,0,0,394,
        395,5,88,0,0,395,396,5,67,0,0,396,397,5,76,0,0,397,398,5,85,0,0,
        398,399,5,68,0,0,399,400,5,69,0,0,400,4,1,0,0,0,401,402,5,83,0,0,
        402,403,5,84,0,0,403,404,5,85,0,0,404,405,5,68,0,0,405,406,5,89,
        0,0,406,407,5,95,0,0,407,408,5,80,0,0,408,409,5,69,0,0,409,410,5,
        82,0,0,410,411,5,73,0,0,411,412,5,79,0,0,412,413,5,68,0,0,413,6,
        1,0,0,0,414,415,5,66,0,0,415,416,5,65,0,0,416,417,5,83,0,0,417,418,
        5,69,0,0,418,419,5,76,0,0,419,420,5,73,0,0,420,421,5,78,0,0,421,
        422,5,69,0,0,422,8,1,0,0,0,423,424,5,70,0,0,424,425,5,79,0,0,425,
        426,5,76,0,0,426,427,5,76,0,0,427,428,5,79,0,0,428,429,5,87,0,0,
        429,430,5,95,0,0,430,431,5,85,0,0,431,432,5,80,0,0,432,10,1,0,0,
        0,433,434,5,73,0,0,434,435,5,78,0,0,435,436,5,68,0,0,436,437,5,69,
        0,0,437,438,5,88,0,0,438,439,5,95,0,0,439,440,5,68,0,0,440,441,5,
        65,0,0,441,442,5,84,0,0,442,443,5,69,0,0,443,12,1,0,0,0,444,445,
        5,69,0,0,445,446,5,86,0,0,446,447,5,69,0,0,447,448,5,78,0,0,448,
        449,5,84,0,0,449,14,1,0,0,0,450,451,5,67,0,0,451,452,5,65,0,0,452,
        453,5,76,0,0,453,454,5,69,0,0,454,455,5,78,0,0,455,456,5,68,0,0,
        456,457,5,65,0,0,457,458,5,82,0,0,458,459,5,95,0,0,459,460,5,68,
        0,0,460,461,5,65,0,0,461,462,5,84,0,0,462,463,5,69,0,0,463,16,1,
        0,0,0,464,465,5,85,0,0,465,466,5,80,0,0,466,467,5,80,0,0,467,468,
        5,69,0,0,468,469,5,82,0,0,469,470,5,95,0,0,470,471,5,68,0,0,471,
        472,5,65,0,0,472,473,5,84,0,0,473,474,5,69,0,0,474,475,5,95,0,0,
        475,476,5,66,0,0,476,477,5,79,0,0,477,478,5,85,0,0,478,479,5,78,
        0,0,479,480,5,68,0,0,480,18,1,0,0,0,481,482,5,76,0,0,482,483,5,79,
        0,0,483,484,5,87,0,0,484,485,5,69,0,0,485,486,5,82,0,0,486,487,5,
        95,0,0,487,488,5,68,0,0,488,489,5,65,0,0,489,490,5,84,0,0,490,491,
        5,69,0,0,491,492,5,95,0,0,492,493,5,66,0,0,493,494,5,79,0,0,494,
        495,5,85,0,0,495,496,5,78,0,0,496,497,5,68,0,0,497,20,1,0,0,0,498,
        499,5,100,0,0,499,500,5,101,0,0,500,501,5,114,0,0,501,502,5,105,
        0,0,502,503,5,118,0,0,503,504,5,101,0,0,504,505,5,100,0,0,505,506,
        5,95,0,0,506,507,5,101,0,0,507,508,5,118,0,0,508,509,5,101,0,0,509,
        510,5,110,0,0,510,511,5,116,0,0,511,512,5,95,0,0,512,513,5,100,0,
        0,513,514,5,97,0,0,514,515,5,116,0,0,515,516,5,101,0,0,516,22,1,
        0,0,0,517,518,5,67,0,0,518,519,5,79,0,0,519,520,5,78,0,0,520,521,
        5,83,0,0,521,522,5,84,0,0,522,523,5,82,0,0,523,524,5,65,0,0,524,
        525,5,73,0,0,525,526,5,78,0,0,526,527,5,84,0,0,527,528,5,83,0,0,
        528,24,1,0,0,0,529,530,5,65,0,0,530,531,5,78,0,0,531,532,5,89,0,
        0,532,533,5,95,0,0,533,534,5,79,0,0,534,535,5,82,0,0,535,536,5,68,
        0,0,536,537,5,69,0,0,537,538,5,82,0,0,538,26,1,0,0,0,539,540,5,73,
        0,0,540,541,5,83,0,0,541,542,5,95,0,0,542,543,5,69,0,0,543,544,5,
        86,0,0,544,545,5,69,0,0,545,546,5,78,0,0,546,547,5,84,0,0,547,548,
        5,95,0,0,548,549,5,68,0,0,549,550,5,65,0,0,550,551,5,84,0,0,551,
        552,5,69,0,0,552,28,1,0,0,0,553,556,3,31,15,0,554,556,3,33,16,0,
        555,553,1,0,0,0,555,554,1,0,0,0,556,30,1,0,0,0,557,558,5,84,0,0,
        558,559,5,67,0,0,559,32,1,0,0,0,560,561,5,84,0,0,561,562,5,69,0,
        0,562,563,5,77,0,0,563,564,5,80,0,0,564,565,5,79,0,0,565,566,5,82,
        0,0,566,567,5,65,0,0,567,568,5,76,0,0,568,569,5,95,0,0,569,570,5,
        67,0,0,570,571,5,79,0,0,571,572,5,78,0,0,572,573,5,83,0,0,573,574,
        5,84,0,0,574,575,5,82,0,0,575,576,5,65,0,0,576,577,5,73,0,0,577,
        578,5,78,0,0,578,579,5,84,0,0,579,34,1,0,0,0,580,581,5,80,0,0,581,
        582,5,79,0,0,582,583,5,83,0,0,583,584,5,73,0,0,584,585,5,84,0,0,
        585,586,5,73,0,0,586,587,5,79,0,0,587,588,5,78,0,0,588,36,1,0,0,
        0,589,592,3,39,19,0,590,592,3,41,20,0,591,589,1,0,0,0,591,590,1,
        0,0,0,592,38,1,0,0,0,593,594,5,67,0,0,594,595,5,79,0,0,595,596,5,
        78,0,0,596,597,5,67,0,0,597,598,5,69,0,0,598,599,5,80,0,0,599,600,
        5,84,0,0,600,601,5,95,0,0,601,602,5,70,0,0,602,603,5,73,0,0,603,
        604,5,76,0,0,604,605,5,84,0,0,605,606,5,69,0,0,606,607,5,82,0,0,
        607,40,1,0,0,0,608,609,5,67,0,0,609,610,5,70,0,0,610,42,1,0,0,0,
        611,614,3,45,22,0,612,614,3,47,23,0,613,611,1,0,0,0,613,612,1,0,
        0,0,614,44,1,0,0,0,615,616,5,78,0,0,616,617,5,85,0,0,617,618,5,77,
        0,0,618,619,5,69,0,0,619,620,5,82,0,0,620,621,5,73,0,0,621,622,5,
        67,0,0,622,623,5,95,0,0,623,624,5,70,0,0,624,625,5,73,0,0,625,626,
        5,76,0,0,626,627,5,84,0,0,627,628,5,69,0,0,628,629,5,82,0,0,629,
        46,1,0,0,0,630,631,5,78,0,0,631,632,5,70,0,0,632,48,1,0,0,0,633,
        636,3,51,25,0,634,636,3,53,26,0,635,633,1,0,0,0,635,634,1,0,0,0,
        636,50,1,0,0,0,637,638,5,83,0,0,638,639,5,84,0,0,639,640,5,82,0,
        0,640,641,5,73,0,0,641,642,5,78,0,0,642,643,5,71,0,0,643,644,5,95,
        0,0,644,645,5,70,0,0,645,646,5,73,0,0,646,647,5,76,0,0,647,648,5,
        84,0,0,648,649,5,69,0,0,649,650,5,82,0,0,650,52,1,0,0,0,651,652,
        5,83,0,0,652,653,5,70,0,0,653,54,1,0,0,0,654,657,3,57,28,0,655,657,
        3,59,29,0,656,654,1,0,0,0,656,655,1,0,0,0,657,56,1,0,0,0,658,659,
        5,85,0,0,659,660,5,78,0,0,660,661,5,73,0,0,661,662,5,81,0,0,662,
        663,5,85,0,0,663,664,5,69,0,0,664,665,5,78,0,0,665,666,5,69,0,0,
        666,667,5,83,0,0,667,668,5,83,0,0,668,669,5,95,0,0,669,670,5,70,
        0,0,670,671,5,73,0,0,671,672,5,76,0,0,672,673,5,84,0,0,673,674,5,
        69,0,0,674,675,5,82,0,0,675,58,1,0,0,0,676,677,5,85,0,0,677,678,
        5,70,0,0,678,60,1,0,0,0,679,682,3,63,31,0,680,682,3,65,32,0,681,
        679,1,0,0,0,681,680,1,0,0,0,682,62,1,0,0,0,683,684,5,82,0,0,684,
        685,5,69,0,0,685,686,5,76,0,0,686,687,5,65,0,0,687,688,5,84,0,0,
        688,689,5,69,0,0,689,690,5,68,0,0,690,691,5,95,0,0,691,692,5,69,
        0,0,692,693,5,78,0,0,693,694,5,84,0,0,694,695,5,73,0,0,695,696,5,
        84,0,0,696,697,5,89,0,0,697,698,5,95,0,0,698,699,5,70,0,0,699,700,
        5,73,0,0,700,701,5,76,0,0,701,702,5,84,0,0,702,703,5,69,0,0,703,
        704,5,82,0,0,704,64,1,0,0,0,705,706,5,82,0,0,706,707,5,70,0,0,707,
        66,1,0,0,0,708,709,3,283,141,0,709,710,3,133,66,0,710,711,3,179,
        89,0,711,68,1,0,0,0,712,713,3,285,142,0,713,714,3,133,66,0,714,715,
        3,179,89,0,715,70,1,0,0,0,716,717,3,287,143,0,717,718,3,133,66,0,
        718,719,3,179,89,0,719,72,1,0,0,0,720,721,3,289,144,0,721,722,3,
        133,66,0,722,723,3,179,89,0,723,74,1,0,0,0,724,725,3,291,145,0,725,
        726,3,133,66,0,726,727,3,179,89,0,727,76,1,0,0,0,728,729,3,293,146,
        0,729,730,3,133,66,0,730,731,3,179,89,0,731,78,1,0,0,0,732,733,3,
        295,147,0,733,734,3,133,66,0,734,735,3,179,89,0,735,80,1,0,0,0,736,
        737,3,297,148,0,737,738,3,133,66,0,738,739,3,179,89,0,739,82,1,0,
        0,0,740,741,3,299,149,0,741,742,3,133,66,0,742,743,3,179,89,0,743,
        84,1,0,0,0,744,748,3,139,69,0,745,748,3,141,70,0,746,748,3,143,71,
        0,747,744,1,0,0,0,747,745,1,0,0,0,747,746,1,0,0,0,748,749,1,0,0,
        0,749,750,3,133,66,0,750,751,3,179,89,0,751,86,1,0,0,0,752,753,3,
        301,150,0,753,754,3,133,66,0,754,755,3,179,89,0,755,88,1,0,0,0,756,
        757,3,303,151,0,757,758,3,133,66,0,758,759,3,179,89,0,759,90,1,0,
        0,0,760,761,3,305,152,0,761,762,3,133,66,0,762,763,3,179,89,0,763,
        92,1,0,0,0,764,765,3,307,153,0,765,766,3,133,66,0,766,767,3,179,
        89,0,767,94,1,0,0,0,768,769,3,309,154,0,769,770,3,133,66,0,770,771,
        3,179,89,0,771,96,1,0,0,0,772,773,3,313,156,0,773,774,3,133,66,0,
        774,775,3,179,89,0,775,98,1,0,0,0,776,777,3,315,157,0,777,778,3,
        133,66,0,778,779,3,179,89,0,779,100,1,0,0,0,780,781,3,317,158,0,
        781,782,3,133,66,0,782,783,3,179,89,0,783,102,1,0,0,0,784,788,3,
        145,72,0,785,788,3,147,73,0,786,788,3,149,74,0,787,784,1,0,0,0,787,
        785,1,0,0,0,787,786,1,0,0,0,788,789,1,0,0,0,789,790,3,133,66,0,790,
        791,3,179,89,0,791,104,1,0,0,0,792,793,5,67,0,0,793,794,5,79,0,0,
        794,795,5,78,0,0,795,796,5,67,0,0,796,797,5,69,0,0,797,798,5,80,
        0,0,798,799,5,84,0,0,799,800,5,95,0,0,800,801,5,71,0,0,801,802,5,
        82,0,0,802,803,5,79,0,0,803,804,5,85,0,0,804,805,5,80,0,0,805,806,
        1,0,0,0,806,807,3,133,66,0,807,808,3,179,89,0,808,106,1,0,0,0,809,
        810,3,265,132,0,810,811,3,133,66,0,811,812,3,179,89,0,812,108,1,
        0,0,0,813,814,3,267,133,0,814,815,3,133,66,0,815,816,3,179,89,0,
        816,110,1,0,0,0,817,818,3,269,134,0,818,819,3,133,66,0,819,820,3,
        179,89,0,820,112,1,0,0,0,821,822,3,271,135,0,822,823,3,133,66,0,
        823,824,3,179,89,0,824,114,1,0,0,0,825,826,3,273,136,0,826,827,3,
        133,66,0,827,828,3,179,89,0,828,116,1,0,0,0,829,830,3,275,137,0,
        830,831,3,133,66,0,831,832,3,179,89,0,832,118,1,0,0,0,833,834,3,
        277,138,0,834,835,3,133,66,0,835,836,3,179,89,0,836,120,1,0,0,0,
        837,838,3,279,139,0,838,839,3,133,66,0,839,840,3,179,89,0,840,122,
        1,0,0,0,841,842,3,281,140,0,842,843,3,133,66,0,843,844,3,179,89,
        0,844,124,1,0,0,0,845,846,3,151,75,0,846,847,3,133,66,0,847,848,
        3,179,89,0,848,126,1,0,0,0,849,850,3,153,76,0,850,851,3,133,66,0,
        851,852,3,179,89,0,852,128,1,0,0,0,853,854,3,155,77,0,854,855,3,
        133,66,0,855,856,3,179,89,0,856,130,1,0,0,0,857,858,3,135,67,0,858,
        859,3,133,66,0,859,860,3,179,89,0,860,132,1,0,0,0,861,862,5,58,0,
        0,862,863,5,58,0,0,863,134,1,0,0,0,864,865,5,83,0,0,865,866,5,85,
        0,0,866,867,5,66,0,0,867,868,5,74,0,0,868,869,5,69,0,0,869,870,5,
        67,0,0,870,871,5,84,0,0,871,872,5,83,0,0,872,873,5,95,0,0,873,874,
        5,86,0,0,874,875,5,65,0,0,875,876,5,82,0,0,876,877,5,73,0,0,877,
        878,5,65,0,0,878,879,5,66,0,0,879,880,5,76,0,0,880,881,5,69,0,0,
        881,136,1,0,0,0,882,884,7,0,0,0,883,882,1,0,0,0,884,885,1,0,0,0,
        885,883,1,0,0,0,885,886,1,0,0,0,886,887,1,0,0,0,887,889,5,47,0,0,
        888,890,7,1,0,0,889,888,1,0,0,0,890,891,1,0,0,0,891,889,1,0,0,0,
        891,892,1,0,0,0,892,138,1,0,0,0,893,894,5,81,0,0,894,895,5,85,0,
        0,895,896,5,65,0,0,896,897,5,76,0,0,897,898,5,73,0,0,898,899,5,70,
        0,0,899,900,5,73,0,0,900,901,5,69,0,0,901,902,5,68,0,0,902,903,5,
        95,0,0,903,904,5,77,0,0,904,905,5,69,0,0,905,906,5,82,0,0,906,907,
        5,71,0,0,907,908,5,69,0,0,908,909,5,68,0,0,909,910,5,95,0,0,910,
        911,5,69,0,0,911,912,5,86,0,0,912,913,5,69,0,0,913,914,5,78,0,0,
        914,915,5,84,0,0,915,140,1,0,0,0,916,917,5,81,0,0,917,918,5,85,0,
        0,918,919,5,65,0,0,919,920,5,76,0,0,920,921,5,73,0,0,921,922,5,70,
        0,0,922,923,5,73,0,0,923,924,5,69,0,0,924,925,5,68,0,0,925,926,5,
        95,0,0,926,927,5,83,0,0,927,928,5,69,0,0,928,929,5,81,0,0,929,930,
        5,85,0,0,930,931,5,69,0,0,931,932,5,78,0,0,932,933,5,67,0,0,933,
        934,5,69,0,0,934,935,5,95,0,0,935,936,5,69,0,0,936,937,5,86,0,0,
        937,938,5,69,0,0,938,939,5,78,0,0,939,940,5,84,0,0,940,142,1,0,0,
        0,941,942,5,81,0,0,942,943,5,85,0,0,943,944,5,65,0,0,944,945,5,76,
        0,0,945,946,5,73,0,0,946,947,5,70,0,0,947,948,5,73,0,0,948,949,5,
        69,0,0,949,950,5,68,0,0,950,951,5,95,0,0,951,952,5,73,0,0,952,953,
        5,78,0,0,953,954,5,83,0,0,954,955,5,84,0,0,955,956,5,65,0,0,956,
        957,5,78,0,0,957,958,5,67,0,0,958,959,5,69,0,0,959,960,5,95,0,0,
        960,961,5,69,0,0,961,962,5,86,0,0,962,963,5,69,0,0,963,964,5,78,
        0,0,964,965,5,84,0,0,965,144,1,0,0,0,966,967,5,83,0,0,967,968,5,
        85,0,0,968,969,5,66,0,0,969,970,5,74,0,0,970,971,5,69,0,0,971,972,
        5,67,0,0,972,973,5,84,0,0,973,974,5,95,0,0,974,975,5,86,0,0,975,
        976,5,65,0,0,976,977,5,82,0,0,977,978,5,73,0,0,978,979,5,65,0,0,
        979,980,5,66,0,0,980,981,5,76,0,0,981,982,5,69,0,0,982,983,5,95,
        0,0,983,984,5,77,0,0,984,985,5,69,0,0,985,986,5,82,0,0,986,987,5,
        71,0,0,987,988,5,69,0,0,988,989,5,68,0,0,989,990,5,95,0,0,990,991,
        5,69,0,0,991,992,5,86,0,0,992,993,5,69,0,0,993,994,5,78,0,0,994,
        995,5,84,0,0,995,146,1,0,0,0,996,997,5,83,0,0,997,998,5,85,0,0,998,
        999,5,66,0,0,999,1000,5,74,0,0,1000,1001,5,69,0,0,1001,1002,5,67,
        0,0,1002,1003,5,84,0,0,1003,1004,5,95,0,0,1004,1005,5,86,0,0,1005,
        1006,5,65,0,0,1006,1007,5,82,0,0,1007,1008,5,73,0,0,1008,1009,5,
        65,0,0,1009,1010,5,66,0,0,1010,1011,5,76,0,0,1011,1012,5,69,0,0,
        1012,1013,5,95,0,0,1013,1014,5,83,0,0,1014,1015,5,69,0,0,1015,1016,
        5,81,0,0,1016,1017,5,85,0,0,1017,1018,5,69,0,0,1018,1019,5,78,0,
        0,1019,1020,5,67,0,0,1020,1021,5,69,0,0,1021,1022,5,95,0,0,1022,
        1023,5,69,0,0,1023,1024,5,86,0,0,1024,1025,5,69,0,0,1025,1026,5,
        78,0,0,1026,1027,5,84,0,0,1027,148,1,0,0,0,1028,1029,5,83,0,0,1029,
        1030,5,85,0,0,1030,1031,5,66,0,0,1031,1032,5,74,0,0,1032,1033,5,
        69,0,0,1033,1034,5,67,0,0,1034,1035,5,84,0,0,1035,1036,5,95,0,0,
        1036,1037,5,86,0,0,1037,1038,5,65,0,0,1038,1039,5,82,0,0,1039,1040,
        5,73,0,0,1040,1041,5,65,0,0,1041,1042,5,66,0,0,1042,1043,5,76,0,
        0,1043,1044,5,69,0,0,1044,1045,5,95,0,0,1045,1046,5,73,0,0,1046,
        1047,5,78,0,0,1047,1048,5,83,0,0,1048,1049,5,84,0,0,1049,1050,5,
        65,0,0,1050,1051,5,78,0,0,1051,1052,5,67,0,0,1052,1053,5,69,0,0,
        1053,1054,5,95,0,0,1054,1055,5,69,0,0,1055,1056,5,86,0,0,1056,1057,
        5,69,0,0,1057,1058,5,78,0,0,1058,1059,5,84,0,0,1059,150,1,0,0,0,
        1060,1061,5,77,0,0,1061,1062,5,69,0,0,1062,1063,5,82,0,0,1063,1064,
        5,71,0,0,1064,1065,5,69,0,0,1065,1066,5,68,0,0,1066,1067,5,95,0,
        0,1067,1068,5,69,0,0,1068,1069,5,86,0,0,1069,1070,5,69,0,0,1070,
        1071,5,78,0,0,1071,1072,5,84,0,0,1072,152,1,0,0,0,1073,1074,5,83,
        0,0,1074,1075,5,69,0,0,1075,1076,5,81,0,0,1076,1077,5,85,0,0,1077,
        1078,5,69,0,0,1078,1079,5,78,0,0,1079,1080,5,67,0,0,1080,1081,5,
        69,0,0,1081,1082,5,95,0,0,1082,1083,5,69,0,0,1083,1084,5,86,0,0,
        1084,1085,5,69,0,0,1085,1086,5,78,0,0,1086,1087,5,84,0,0,1087,154,
        1,0,0,0,1088,1089,5,73,0,0,1089,1090,5,78,0,0,1090,1091,5,83,0,0,
        1091,1092,5,84,0,0,1092,1093,5,65,0,0,1093,1094,5,78,0,0,1094,1095,
        5,67,0,0,1095,1096,5,69,0,0,1096,1097,5,95,0,0,1097,1098,5,69,0,
        0,1098,1099,5,86,0,0,1099,1100,5,69,0,0,1100,1101,5,78,0,0,1101,
        1102,5,84,0,0,1102,156,1,0,0,0,1103,1104,5,68,0,0,1104,1105,5,69,
        0,0,1105,1106,5,82,0,0,1106,1107,5,73,0,0,1107,1108,5,86,0,0,1108,
        1109,5,69,0,0,1109,1110,5,68,0,0,1110,1111,5,95,0,0,1111,1112,5,
        69,0,0,1112,1113,5,86,0,0,1113,1114,5,69,0,0,1114,1115,5,78,0,0,
        1115,1116,5,84,0,0,1116,158,1,0,0,0,1117,1118,5,47,0,0,1118,1119,
        5,47,0,0,1119,1123,1,0,0,0,1120,1122,8,2,0,0,1121,1120,1,0,0,0,1122,
        1125,1,0,0,0,1123,1121,1,0,0,0,1123,1124,1,0,0,0,1124,1126,1,0,0,
        0,1125,1123,1,0,0,0,1126,1127,6,79,0,0,1127,160,1,0,0,0,1128,1130,
        7,3,0,0,1129,1128,1,0,0,0,1130,1131,1,0,0,0,1131,1129,1,0,0,0,1131,
        1132,1,0,0,0,1132,162,1,0,0,0,1133,1134,7,4,0,0,1134,1138,7,5,0,
        0,1135,1136,7,6,0,0,1136,1138,7,7,0,0,1137,1133,1,0,0,0,1137,1135,
        1,0,0,0,1138,164,1,0,0,0,1139,1140,7,4,0,0,1140,1146,7,5,0,0,1141,
        1142,7,8,0,0,1142,1146,7,3,0,0,1143,1144,7,9,0,0,1144,1146,7,10,
        0,0,1145,1139,1,0,0,0,1145,1141,1,0,0,0,1145,1143,1,0,0,0,1146,166,
        1,0,0,0,1147,1148,7,8,0,0,1148,1149,7,3,0,0,1149,1150,7,3,0,0,1150,
        1151,7,3,0,0,1151,168,1,0,0,0,1152,1153,3,167,83,0,1153,1154,5,45,
        0,0,1154,1155,3,163,81,0,1155,1156,5,45,0,0,1156,1157,3,165,82,0,
        1157,170,1,0,0,0,1158,1159,5,40,0,0,1159,172,1,0,0,0,1160,1161,5,
        41,0,0,1161,174,1,0,0,0,1162,1163,5,59,0,0,1163,176,1,0,0,0,1164,
        1165,5,44,0,0,1165,178,1,0,0,0,1166,1170,5,34,0,0,1167,1171,3,183,
        91,0,1168,1171,3,185,92,0,1169,1171,3,187,93,0,1170,1167,1,0,0,0,
        1170,1168,1,0,0,0,1170,1169,1,0,0,0,1171,1172,1,0,0,0,1172,1170,
        1,0,0,0,1172,1173,1,0,0,0,1173,1174,1,0,0,0,1174,1175,5,34,0,0,1175,
        180,1,0,0,0,1176,1177,7,11,0,0,1177,182,1,0,0,0,1178,1181,3,181,
        90,0,1179,1181,7,3,0,0,1180,1178,1,0,0,0,1180,1179,1,0,0,0,1181,
        184,1,0,0,0,1182,1183,7,12,0,0,1183,186,1,0,0,0,1184,1185,7,13,0,
        0,1185,188,1,0,0,0,1186,1187,5,61,0,0,1187,190,1,0,0,0,1188,1189,
        5,42,0,0,1189,192,1,0,0,0,1190,1191,5,47,0,0,1191,194,1,0,0,0,1192,
        1193,5,43,0,0,1193,196,1,0,0,0,1194,1195,5,45,0,0,1195,198,1,0,0,
        0,1196,1197,5,67,0,0,1197,1198,5,79,0,0,1198,1199,5,78,0,0,1199,
        1200,5,84,0,0,1200,1201,5,65,0,0,1201,1202,5,73,0,0,1202,1203,5,
        78,0,0,1203,1204,5,83,0,0,1204,200,1,0,0,0,1205,1206,5,33,0,0,1206,
        1207,5,61,0,0,1207,202,1,0,0,0,1208,1209,5,60,0,0,1209,1210,5,61,
        0,0,1210,204,1,0,0,0,1211,1212,5,62,0,0,1212,1213,5,61,0,0,1213,
        206,1,0,0,0,1214,1215,5,60,0,0,1215,208,1,0,0,0,1216,1217,5,62,0,
        0,1217,210,1,0,0,0,1218,1219,5,77,0,0,1219,1220,5,65,0,0,1220,1221,
        5,88,0,0,1221,212,1,0,0,0,1222,1223,5,77,0,0,1223,1224,5,73,0,0,
        1224,1225,5,78,0,0,1225,214,1,0,0,0,1226,1227,5,65,0,0,1227,1228,
        5,86,0,0,1228,1229,5,71,0,0,1229,216,1,0,0,0,1230,1231,5,67,0,0,
        1231,1232,5,79,0,0,1232,1233,5,85,0,0,1233,1234,5,78,0,0,1234,1235,
        5,84,0,0,1235,218,1,0,0,0,1236,1237,5,76,0,0,1237,1238,5,69,0,0,
        1238,1239,5,65,0,0,1239,1240,5,83,0,0,1240,1241,5,84,0,0,1241,220,
        1,0,0,0,1242,1243,5,71,0,0,1243,1244,5,82,0,0,1244,1245,5,69,0,0,
        1245,1246,5,65,0,0,1246,1247,5,84,0,0,1247,1248,5,69,0,0,1248,1249,
        5,83,0,0,1249,1250,5,84,0,0,1250,222,1,0,0,0,1251,1252,5,73,0,0,
        1252,1253,5,78,0,0,1253,224,1,0,0,0,1254,1255,5,65,0,0,1255,1256,
        5,78,0,0,1256,1257,5,68,0,0,1257,226,1,0,0,0,1258,1259,5,79,0,0,
        1259,1260,5,82,0,0,1260,228,1,0,0,0,1261,1262,5,78,0,0,1262,1263,
        5,79,0,0,1263,1264,5,84,0,0,1264,230,1,0,0,0,1265,1266,5,67,0,0,
        1266,1267,5,79,0,0,1267,1268,5,77,0,0,1268,1269,5,80,0,0,1269,1270,
        5,76,0,0,1270,1271,5,69,0,0,1271,1272,5,77,0,0,1272,1273,5,69,0,
        0,1273,1274,5,78,0,0,1274,1275,5,84,0,0,1275,232,1,0,0,0,1276,1277,
        5,85,0,0,1277,1278,5,78,0,0,1278,1279,5,73,0,0,1279,1280,5,79,0,
        0,1280,1281,5,78,0,0,1281,234,1,0,0,0,1282,1283,5,73,0,0,1283,1284,
        5,78,0,0,1284,1285,5,84,0,0,1285,1286,5,69,0,0,1286,1287,5,82,0,
        0,1287,1288,5,83,0,0,1288,1289,5,69,0,0,1289,1290,5,67,0,0,1290,
        1291,5,84,0,0,1291,1292,5,73,0,0,1292,1293,5,79,0,0,1293,1294,5,
        78,0,0,1294,236,1,0,0,0,1295,1296,5,68,0,0,1296,1297,5,73,0,0,1297,
        1298,5,70,0,0,1298,1299,5,70,0,0,1299,1300,5,69,0,0,1300,1301,5,
        82,0,0,1301,1302,5,69,0,0,1302,1303,5,78,0,0,1303,1304,5,67,0,0,
        1304,1305,5,69,0,0,1305,238,1,0,0,0,1306,1307,5,73,0,0,1307,1308,
        5,78,0,0,1308,1309,5,68,0,0,1309,1310,5,69,0,0,1310,1311,5,88,0,
        0,1311,240,1,0,0,0,1312,1313,3,243,121,0,1313,242,1,0,0,0,1314,1315,
        5,68,0,0,1315,1316,5,65,0,0,1316,1317,5,89,0,0,1317,1318,5,83,0,
        0,1318,244,1,0,0,0,1319,1320,5,87,0,0,1320,1321,5,69,0,0,1321,1322,
        5,69,0,0,1322,1323,5,75,0,0,1323,1324,5,83,0,0,1324,246,1,0,0,0,
        1325,1326,5,77,0,0,1326,1327,5,79,0,0,1327,1328,5,78,0,0,1328,1329,
        5,84,0,0,1329,1330,5,72,0,0,1330,1331,5,83,0,0,1331,248,1,0,0,0,
        1332,1333,5,89,0,0,1333,1334,5,69,0,0,1334,1335,5,65,0,0,1335,1336,
        5,82,0,0,1336,1337,5,83,0,0,1337,250,1,0,0,0,1338,1339,5,77,0,0,
        1339,1340,5,73,0,0,1340,1341,5,78,0,0,1341,1342,5,73,0,0,1342,1343,
        5,77,0,0,1343,1344,5,85,0,0,1344,1345,5,77,0,0,1345,1346,5,95,0,
        0,1346,1347,5,66,0,0,1347,1348,5,69,0,0,1348,1349,5,84,0,0,1349,
        1350,5,87,0,0,1350,1351,5,69,0,0,1351,1352,5,69,0,0,1352,1353,5,
        78,0,0,1353,252,1,0,0,0,1354,1355,5,77,0,0,1355,1356,5,65,0,0,1356,
        1357,5,88,0,0,1357,1358,5,73,0,0,1358,1359,5,77,0,0,1359,1360,5,
        85,0,0,1360,1361,5,77,0,0,1361,1362,5,95,0,0,1362,1363,5,66,0,0,
        1363,1364,5,69,0,0,1364,1365,5,84,0,0,1365,1366,5,87,0,0,1366,1367,
        5,69,0,0,1367,1368,5,69,0,0,1368,1369,5,78,0,0,1369,254,1,0,0,0,
        1370,1371,5,84,0,0,1371,1372,5,79,0,0,1372,1373,5,84,0,0,1373,1374,
        5,65,0,0,1374,1375,5,76,0,0,1375,1376,5,95,0,0,1376,1377,5,66,0,
        0,1377,1378,5,69,0,0,1378,1379,5,84,0,0,1379,1380,5,87,0,0,1380,
        1381,5,69,0,0,1381,1382,5,69,0,0,1382,1383,5,78,0,0,1383,256,1,0,
        0,0,1384,1385,5,70,0,0,1385,1386,5,73,0,0,1386,1387,5,88,0,0,1387,
        1388,5,69,0,0,1388,1389,5,68,0,0,1389,1390,5,95,0,0,1390,1391,5,
        87,0,0,1391,1392,5,73,0,0,1392,1393,5,78,0,0,1393,1394,5,68,0,0,
        1394,1395,5,79,0,0,1395,1396,5,87,0,0,1396,258,1,0,0,0,1397,1398,
        5,82,0,0,1398,1399,5,79,0,0,1399,1400,5,76,0,0,1400,1401,5,76,0,
        0,1401,1402,5,73,0,0,1402,1403,5,78,0,0,1403,1404,5,71,0,0,1404,
        1405,5,95,0,0,1405,1406,5,87,0,0,1406,1407,5,73,0,0,1407,1408,5,
        78,0,0,1408,1409,5,68,0,0,1409,1410,5,79,0,0,1410,1411,5,87,0,0,
        1411,260,1,0,0,0,1412,1413,5,46,0,0,1413,262,1,0,0,0,1414,1416,7,
        14,0,0,1415,1414,1,0,0,0,1416,1417,1,0,0,0,1417,1415,1,0,0,0,1417,
        1418,1,0,0,0,1418,1419,1,0,0,0,1419,1420,6,131,0,0,1420,264,1,0,
        0,0,1421,1422,5,67,0,0,1422,1423,5,65,0,0,1423,1424,5,82,0,0,1424,
        1425,5,69,0,0,1425,1426,5,95,0,0,1426,1427,5,83,0,0,1427,1428,5,
        73,0,0,1428,1429,5,84,0,0,1429,1430,5,69,0,0,1430,266,1,0,0,0,1431,
        1432,5,67,0,0,1432,1433,5,79,0,0,1433,1434,5,78,0,0,1434,1435,5,
        68,0,0,1435,1436,5,73,0,0,1436,1437,5,84,0,0,1437,1438,5,73,0,0,
        1438,1439,5,79,0,0,1439,1440,5,78,0,0,1440,1441,5,95,0,0,1441,1442,
        5,79,0,0,1442,1443,5,67,0,0,1443,1444,5,67,0,0,1444,1445,5,85,0,
        0,1445,1446,5,82,0,0,1446,1447,5,82,0,0,1447,1448,5,69,0,0,1448,
        1449,5,78,0,0,1449,1450,5,67,0,0,1450,1451,5,69,0,0,1451,268,1,0,
        0,0,1452,1453,5,68,0,0,1453,1454,5,82,0,0,1454,1455,5,85,0,0,1455,
        1456,5,71,0,0,1456,1457,5,95,0,0,1457,1458,5,69,0,0,1458,1459,5,
        88,0,0,1459,1460,5,80,0,0,1460,1461,5,79,0,0,1461,1462,5,83,0,0,
        1462,1463,5,85,0,0,1463,1464,5,82,0,0,1464,1465,5,69,0,0,1465,270,
        1,0,0,0,1466,1467,5,77,0,0,1467,1468,5,69,0,0,1468,1469,5,65,0,0,
        1469,1470,5,83,0,0,1470,1471,5,85,0,0,1471,1472,5,82,0,0,1472,1473,
        5,69,0,0,1473,1474,5,77,0,0,1474,1475,5,69,0,0,1475,1476,5,78,0,
        0,1476,1477,5,84,0,0,1477,272,1,0,0,0,1478,1479,5,79,0,0,1479,1480,
        5,66,0,0,1480,1481,5,83,0,0,1481,1482,5,69,0,0,1482,1483,5,82,0,
        0,1483,1484,5,86,0,0,1484,1485,5,65,0,0,1485,1486,5,84,0,0,1486,
        1487,5,73,0,0,1487,1488,5,79,0,0,1488,1489,5,78,0,0,1489,274,1,0,
        0,0,1490,1491,5,80,0,0,1491,1492,5,69,0,0,1492,1493,5,82,0,0,1493,
        1494,5,83,0,0,1494,1495,5,79,0,0,1495,1496,5,78,0,0,1496,276,1,0,
        0,0,1497,1498,5,80,0,0,1498,1499,5,82,0,0,1499,1500,5,79,0,0,1500,
        1501,5,67,0,0,1501,1502,5,69,0,0,1502,1503,5,68,0,0,1503,1504,5,
        85,0,0,1504,1505,5,82,0,0,1505,1506,5,69,0,0,1506,1507,5,95,0,0,
        1507,1508,5,79,0,0,1508,1509,5,67,0,0,1509,1510,5,67,0,0,1510,1511,
        5,85,0,0,1511,1512,5,82,0,0,1512,1513,5,82,0,0,1513,1514,5,69,0,
        0,1514,1515,5,78,0,0,1515,1516,5,67,0,0,1516,1517,5,69,0,0,1517,
        278,1,0,0,0,1518,1519,5,80,0,0,1519,1520,5,82,0,0,1520,1521,5,79,
        0,0,1521,1522,5,86,0,0,1522,1523,5,73,0,0,1523,1524,5,68,0,0,1524,
        1525,5,69,0,0,1525,1526,5,82,0,0,1526,280,1,0,0,0,1527,1528,5,86,
        0,0,1528,1529,5,73,0,0,1529,1530,5,83,0,0,1530,1531,5,73,0,0,1531,
        1532,5,84,0,0,1532,1533,5,95,0,0,1533,1534,5,79,0,0,1534,1535,5,
        67,0,0,1535,1536,5,67,0,0,1536,1537,5,85,0,0,1537,1538,5,82,0,0,
        1538,1539,5,82,0,0,1539,1540,5,69,0,0,1540,1541,5,78,0,0,1541,1542,
        5,67,0,0,1542,1543,5,69,0,0,1543,282,1,0,0,0,1544,1545,5,81,0,0,
        1545,1546,5,85,0,0,1546,1547,5,65,0,0,1547,1548,5,76,0,0,1548,1549,
        5,73,0,0,1549,1550,5,70,0,0,1550,1551,5,73,0,0,1551,1552,5,69,0,
        0,1552,1553,5,68,0,0,1553,1554,5,95,0,0,1554,1555,5,67,0,0,1555,
        1556,5,65,0,0,1556,1557,5,82,0,0,1557,1558,5,69,0,0,1558,1559,5,
        95,0,0,1559,1560,5,83,0,0,1560,1561,5,73,0,0,1561,1562,5,84,0,0,
        1562,1563,5,69,0,0,1563,284,1,0,0,0,1564,1565,5,81,0,0,1565,1566,
        5,85,0,0,1566,1567,5,65,0,0,1567,1568,5,76,0,0,1568,1569,5,73,0,
        0,1569,1570,5,70,0,0,1570,1571,5,73,0,0,1571,1572,5,69,0,0,1572,
        1573,5,68,0,0,1573,1574,5,95,0,0,1574,1575,5,67,0,0,1575,1576,5,
        79,0,0,1576,1577,5,78,0,0,1577,1578,5,68,0,0,1578,1579,5,73,0,0,
        1579,1580,5,84,0,0,1580,1581,5,73,0,0,1581,1582,5,79,0,0,1582,1583,
        5,78,0,0,1583,1584,5,95,0,0,1584,1585,5,79,0,0,1585,1586,5,67,0,
        0,1586,1587,5,67,0,0,1587,1588,5,85,0,0,1588,1589,5,82,0,0,1589,
        1590,5,82,0,0,1590,1591,5,69,0,0,1591,1592,5,78,0,0,1592,1593,5,
        67,0,0,1593,1594,5,69,0,0,1594,286,1,0,0,0,1595,1596,5,81,0,0,1596,
        1597,5,85,0,0,1597,1598,5,65,0,0,1598,1599,5,76,0,0,1599,1600,5,
        73,0,0,1600,1601,5,70,0,0,1601,1602,5,73,0,0,1602,1603,5,69,0,0,
        1603,1604,5,68,0,0,1604,1605,5,95,0,0,1605,1606,5,68,0,0,1606,1607,
        5,82,0,0,1607,1608,5,85,0,0,1608,1609,5,71,0,0,1609,1610,5,95,0,
        0,1610,1611,5,69,0,0,1611,1612,5,88,0,0,1612,1613,5,80,0,0,1613,
        1614,5,79,0,0,1614,1615,5,83,0,0,1615,1616,5,85,0,0,1616,1617,5,
        82,0,0,1617,1618,5,69,0,0,1618,288,1,0,0,0,1619,1620,5,81,0,0,1620,
        1621,5,85,0,0,1621,1622,5,65,0,0,1622,1623,5,76,0,0,1623,1624,5,
        73,0,0,1624,1625,5,70,0,0,1625,1626,5,73,0,0,1626,1627,5,69,0,0,
        1627,1628,5,68,0,0,1628,1629,5,95,0,0,1629,1630,5,77,0,0,1630,1631,
        5,69,0,0,1631,1632,5,65,0,0,1632,1633,5,83,0,0,1633,1634,5,85,0,
        0,1634,1635,5,82,0,0,1635,1636,5,69,0,0,1636,1637,5,77,0,0,1637,
        1638,5,69,0,0,1638,1639,5,78,0,0,1639,1640,5,84,0,0,1640,290,1,0,
        0,0,1641,1642,5,81,0,0,1642,1643,5,85,0,0,1643,1644,5,65,0,0,1644,
        1645,5,76,0,0,1645,1646,5,73,0,0,1646,1647,5,70,0,0,1647,1648,5,
        73,0,0,1648,1649,5,69,0,0,1649,1650,5,68,0,0,1650,1651,5,95,0,0,
        1651,1652,5,79,0,0,1652,1653,5,66,0,0,1653,1654,5,83,0,0,1654,1655,
        5,69,0,0,1655,1656,5,82,0,0,1656,1657,5,86,0,0,1657,1658,5,65,0,
        0,1658,1659,5,84,0,0,1659,1660,5,73,0,0,1660,1661,5,79,0,0,1661,
        1662,5,78,0,0,1662,292,1,0,0,0,1663,1664,5,81,0,0,1664,1665,5,85,
        0,0,1665,1666,5,65,0,0,1666,1667,5,76,0,0,1667,1668,5,73,0,0,1668,
        1669,5,70,0,0,1669,1670,5,73,0,0,1670,1671,5,69,0,0,1671,1672,5,
        68,0,0,1672,1673,5,95,0,0,1673,1674,5,80,0,0,1674,1675,5,69,0,0,
        1675,1676,5,82,0,0,1676,1677,5,83,0,0,1677,1678,5,79,0,0,1678,1679,
        5,78,0,0,1679,294,1,0,0,0,1680,1681,5,81,0,0,1681,1682,5,85,0,0,
        1682,1683,5,65,0,0,1683,1684,5,76,0,0,1684,1685,5,73,0,0,1685,1686,
        5,70,0,0,1686,1687,5,73,0,0,1687,1688,5,69,0,0,1688,1689,5,68,0,
        0,1689,1690,5,95,0,0,1690,1691,5,80,0,0,1691,1692,5,82,0,0,1692,
        1693,5,79,0,0,1693,1694,5,67,0,0,1694,1695,5,69,0,0,1695,1696,5,
        68,0,0,1696,1697,5,85,0,0,1697,1698,5,82,0,0,1698,1699,5,69,0,0,
        1699,1700,5,95,0,0,1700,1701,5,79,0,0,1701,1702,5,67,0,0,1702,1703,
        5,67,0,0,1703,1704,5,85,0,0,1704,1705,5,82,0,0,1705,1706,5,82,0,
        0,1706,1707,5,69,0,0,1707,1708,5,78,0,0,1708,1709,5,67,0,0,1709,
        1710,5,69,0,0,1710,296,1,0,0,0,1711,1712,5,81,0,0,1712,1713,5,85,
        0,0,1713,1714,5,65,0,0,1714,1715,5,76,0,0,1715,1716,5,73,0,0,1716,
        1717,5,70,0,0,1717,1718,5,73,0,0,1718,1719,5,69,0,0,1719,1720,5,
        68,0,0,1720,1721,5,95,0,0,1721,1722,5,80,0,0,1722,1723,5,82,0,0,
        1723,1724,5,79,0,0,1724,1725,5,86,0,0,1725,1726,5,73,0,0,1726,1727,
        5,68,0,0,1727,1728,5,69,0,0,1728,1729,5,82,0,0,1729,298,1,0,0,0,
        1730,1731,5,81,0,0,1731,1732,5,85,0,0,1732,1733,5,65,0,0,1733,1734,
        5,76,0,0,1734,1735,5,73,0,0,1735,1736,5,70,0,0,1736,1737,5,73,0,
        0,1737,1738,5,69,0,0,1738,1739,5,68,0,0,1739,1740,5,95,0,0,1740,
        1741,5,86,0,0,1741,1742,5,73,0,0,1742,1743,5,83,0,0,1743,1744,5,
        73,0,0,1744,1745,5,84,0,0,1745,1746,5,95,0,0,1746,1747,5,79,0,0,
        1747,1748,5,67,0,0,1748,1749,5,67,0,0,1749,1750,5,85,0,0,1750,1751,
        5,82,0,0,1751,1752,5,82,0,0,1752,1753,5,69,0,0,1753,1754,5,78,0,
        0,1754,1755,5,67,0,0,1755,1756,5,69,0,0,1756,300,1,0,0,0,1757,1758,
        5,83,0,0,1758,1759,5,85,0,0,1759,1760,5,66,0,0,1760,1761,5,74,0,
        0,1761,1762,5,69,0,0,1762,1763,5,67,0,0,1763,1764,5,84,0,0,1764,
        1765,5,95,0,0,1765,1766,5,86,0,0,1766,1767,5,65,0,0,1767,1768,5,
        82,0,0,1768,1769,5,73,0,0,1769,1770,5,65,0,0,1770,1771,5,66,0,0,
        1771,1772,5,76,0,0,1772,1773,5,69,0,0,1773,1774,5,95,0,0,1774,1775,
        5,67,0,0,1775,1776,5,65,0,0,1776,1777,5,82,0,0,1777,1778,5,69,0,
        0,1778,1779,5,95,0,0,1779,1780,5,83,0,0,1780,1781,5,73,0,0,1781,
        1782,5,84,0,0,1782,1783,5,69,0,0,1783,302,1,0,0,0,1784,1785,5,83,
        0,0,1785,1786,5,85,0,0,1786,1787,5,66,0,0,1787,1788,5,74,0,0,1788,
        1789,5,69,0,0,1789,1790,5,67,0,0,1790,1791,5,84,0,0,1791,1792,5,
        95,0,0,1792,1793,5,86,0,0,1793,1794,5,65,0,0,1794,1795,5,82,0,0,
        1795,1796,5,73,0,0,1796,1797,5,65,0,0,1797,1798,5,66,0,0,1798,1799,
        5,76,0,0,1799,1800,5,69,0,0,1800,1801,5,95,0,0,1801,1802,5,67,0,
        0,1802,1803,5,79,0,0,1803,1804,5,78,0,0,1804,1805,5,68,0,0,1805,
        1806,5,73,0,0,1806,1807,5,84,0,0,1807,1808,5,73,0,0,1808,1809,5,
        79,0,0,1809,1810,5,78,0,0,1810,1811,5,95,0,0,1811,1812,5,79,0,0,
        1812,1813,5,67,0,0,1813,1814,5,67,0,0,1814,1815,5,85,0,0,1815,1816,
        5,82,0,0,1816,1817,5,82,0,0,1817,1818,5,69,0,0,1818,1819,5,78,0,
        0,1819,1820,5,67,0,0,1820,1821,5,69,0,0,1821,304,1,0,0,0,1822,1823,
        5,83,0,0,1823,1824,5,85,0,0,1824,1825,5,66,0,0,1825,1826,5,74,0,
        0,1826,1827,5,69,0,0,1827,1828,5,67,0,0,1828,1829,5,84,0,0,1829,
        1830,5,95,0,0,1830,1831,5,86,0,0,1831,1832,5,65,0,0,1832,1833,5,
        82,0,0,1833,1834,5,73,0,0,1834,1835,5,65,0,0,1835,1836,5,66,0,0,
        1836,1837,5,76,0,0,1837,1838,5,69,0,0,1838,1839,5,95,0,0,1839,1840,
        5,68,0,0,1840,1841,5,82,0,0,1841,1842,5,85,0,0,1842,1843,5,71,0,
        0,1843,1844,5,95,0,0,1844,1845,5,69,0,0,1845,1846,5,88,0,0,1846,
        1847,5,80,0,0,1847,1848,5,79,0,0,1848,1849,5,83,0,0,1849,1850,5,
        85,0,0,1850,1851,5,82,0,0,1851,1852,5,69,0,0,1852,306,1,0,0,0,1853,
        1854,5,83,0,0,1854,1855,5,85,0,0,1855,1856,5,66,0,0,1856,1857,5,
        74,0,0,1857,1858,5,69,0,0,1858,1859,5,67,0,0,1859,1860,5,84,0,0,
        1860,1861,5,95,0,0,1861,1862,5,86,0,0,1862,1863,5,65,0,0,1863,1864,
        5,82,0,0,1864,1865,5,73,0,0,1865,1866,5,65,0,0,1866,1867,5,66,0,
        0,1867,1868,5,76,0,0,1868,1869,5,69,0,0,1869,1870,5,95,0,0,1870,
        1871,5,77,0,0,1871,1872,5,69,0,0,1872,1873,5,65,0,0,1873,1874,5,
        83,0,0,1874,1875,5,85,0,0,1875,1876,5,82,0,0,1876,1877,5,69,0,0,
        1877,1878,5,77,0,0,1878,1879,5,69,0,0,1879,1880,5,78,0,0,1880,1881,
        5,84,0,0,1881,308,1,0,0,0,1882,1883,5,83,0,0,1883,1884,5,85,0,0,
        1884,1885,5,66,0,0,1885,1886,5,74,0,0,1886,1887,5,69,0,0,1887,1888,
        5,67,0,0,1888,1889,5,84,0,0,1889,1890,5,95,0,0,1890,1891,5,86,0,
        0,1891,1892,5,65,0,0,1892,1893,5,82,0,0,1893,1894,5,73,0,0,1894,
        1895,5,65,0,0,1895,1896,5,66,0,0,1896,1897,5,76,0,0,1897,1898,5,
        69,0,0,1898,1899,5,95,0,0,1899,1900,5,79,0,0,1900,1901,5,66,0,0,
        1901,1902,5,83,0,0,1902,1903,5,69,0,0,1903,1904,5,82,0,0,1904,1905,
        5,86,0,0,1905,1906,5,65,0,0,1906,1907,5,84,0,0,1907,1908,5,73,0,
        0,1908,1909,5,79,0,0,1909,1910,5,78,0,0,1910,310,1,0,0,0,1911,1912,
        5,83,0,0,1912,1913,5,85,0,0,1913,1914,5,66,0,0,1914,1915,5,74,0,
        0,1915,1916,5,69,0,0,1916,1917,5,67,0,0,1917,1918,5,84,0,0,1918,
        1919,5,95,0,0,1919,1920,5,86,0,0,1920,1921,5,65,0,0,1921,1922,5,
        82,0,0,1922,1923,5,73,0,0,1923,1924,5,65,0,0,1924,1925,5,66,0,0,
        1925,1926,5,76,0,0,1926,1927,5,69,0,0,1927,1928,5,95,0,0,1928,1929,
        5,80,0,0,1929,1930,5,69,0,0,1930,1931,5,82,0,0,1931,1932,5,83,0,
        0,1932,1933,5,79,0,0,1933,1934,5,78,0,0,1934,312,1,0,0,0,1935,1936,
        5,83,0,0,1936,1937,5,85,0,0,1937,1938,5,66,0,0,1938,1939,5,74,0,
        0,1939,1940,5,69,0,0,1940,1941,5,67,0,0,1941,1942,5,84,0,0,1942,
        1943,5,95,0,0,1943,1944,5,86,0,0,1944,1945,5,65,0,0,1945,1946,5,
        82,0,0,1946,1947,5,73,0,0,1947,1948,5,65,0,0,1948,1949,5,66,0,0,
        1949,1950,5,76,0,0,1950,1951,5,69,0,0,1951,1952,5,95,0,0,1952,1953,
        5,80,0,0,1953,1954,5,82,0,0,1954,1955,5,79,0,0,1955,1956,5,67,0,
        0,1956,1957,5,69,0,0,1957,1958,5,68,0,0,1958,1959,5,85,0,0,1959,
        1960,5,82,0,0,1960,1961,5,69,0,0,1961,1962,5,95,0,0,1962,1963,5,
        79,0,0,1963,1964,5,67,0,0,1964,1965,5,67,0,0,1965,1966,5,85,0,0,
        1966,1967,5,82,0,0,1967,1968,5,82,0,0,1968,1969,5,69,0,0,1969,1970,
        5,78,0,0,1970,1971,5,67,0,0,1971,1972,5,69,0,0,1972,314,1,0,0,0,
        1973,1974,5,83,0,0,1974,1975,5,85,0,0,1975,1976,5,66,0,0,1976,1977,
        5,74,0,0,1977,1978,5,69,0,0,1978,1979,5,67,0,0,1979,1980,5,84,0,
        0,1980,1981,5,95,0,0,1981,1982,5,86,0,0,1982,1983,5,65,0,0,1983,
        1984,5,82,0,0,1984,1985,5,73,0,0,1985,1986,5,65,0,0,1986,1987,5,
        66,0,0,1987,1988,5,76,0,0,1988,1989,5,69,0,0,1989,1990,5,95,0,0,
        1990,1991,5,80,0,0,1991,1992,5,82,0,0,1992,1993,5,79,0,0,1993,1994,
        5,86,0,0,1994,1995,5,73,0,0,1995,1996,5,68,0,0,1996,1997,5,69,0,
        0,1997,1998,5,82,0,0,1998,316,1,0,0,0,1999,2000,5,83,0,0,2000,2001,
        5,85,0,0,2001,2002,5,66,0,0,2002,2003,5,74,0,0,2003,2004,5,69,0,
        0,2004,2005,5,67,0,0,2005,2006,5,84,0,0,2006,2007,5,95,0,0,2007,
        2008,5,86,0,0,2008,2009,5,65,0,0,2009,2010,5,82,0,0,2010,2011,5,
        73,0,0,2011,2012,5,65,0,0,2012,2013,5,66,0,0,2013,2014,5,76,0,0,
        2014,2015,5,69,0,0,2015,2016,5,95,0,0,2016,2017,5,86,0,0,2017,2018,
        5,73,0,0,2018,2019,5,83,0,0,2019,2020,5,73,0,0,2020,2021,5,84,0,
        0,2021,2022,5,95,0,0,2022,2023,5,79,0,0,2023,2024,5,67,0,0,2024,
        2025,5,67,0,0,2025,2026,5,85,0,0,2026,2027,5,82,0,0,2027,2028,5,
        82,0,0,2028,2029,5,69,0,0,2029,2030,5,78,0,0,2030,2031,5,67,0,0,
        2031,2032,5,69,0,0,2032,318,1,0,0,0,2033,2034,5,99,0,0,2034,2035,
        5,111,0,0,2035,2036,5,110,0,0,2036,2037,5,100,0,0,2037,2038,5,105,
        0,0,2038,2039,5,116,0,0,2039,2040,5,105,0,0,2040,2041,5,111,0,0,
        2041,2042,5,110,0,0,2042,2043,5,95,0,0,2043,2044,5,115,0,0,2044,
        2045,5,116,0,0,2045,2046,5,97,0,0,2046,2047,5,114,0,0,2047,2048,
        5,116,0,0,2048,2049,5,95,0,0,2049,2050,5,100,0,0,2050,2051,5,97,
        0,0,2051,2052,5,116,0,0,2052,2072,5,101,0,0,2053,2054,5,99,0,0,2054,
        2055,5,111,0,0,2055,2056,5,110,0,0,2056,2057,5,100,0,0,2057,2058,
        5,105,0,0,2058,2059,5,116,0,0,2059,2060,5,105,0,0,2060,2061,5,111,
        0,0,2061,2062,5,110,0,0,2062,2063,5,95,0,0,2063,2064,5,101,0,0,2064,
        2065,5,110,0,0,2065,2066,5,100,0,0,2066,2067,5,95,0,0,2067,2068,
        5,100,0,0,2068,2069,5,97,0,0,2069,2070,5,116,0,0,2070,2072,5,101,
        0,0,2071,2033,1,0,0,0,2071,2053,1,0,0,0,2072,320,1,0,0,0,2073,2074,
        5,100,0,0,2074,2075,5,114,0,0,2075,2076,5,117,0,0,2076,2077,5,103,
        0,0,2077,2078,5,95,0,0,2078,2079,5,101,0,0,2079,2080,5,120,0,0,2080,
        2081,5,112,0,0,2081,2082,5,111,0,0,2082,2083,5,115,0,0,2083,2084,
        5,117,0,0,2084,2085,5,114,0,0,2085,2086,5,101,0,0,2086,2087,5,95,
        0,0,2087,2088,5,115,0,0,2088,2089,5,116,0,0,2089,2090,5,97,0,0,2090,
        2091,5,114,0,0,2091,2092,5,116,0,0,2092,2093,5,95,0,0,2093,2094,
        5,100,0,0,2094,2095,5,97,0,0,2095,2096,5,116,0,0,2096,2120,5,101,
        0,0,2097,2098,5,100,0,0,2098,2099,5,114,0,0,2099,2100,5,117,0,0,
        2100,2101,5,103,0,0,2101,2102,5,95,0,0,2102,2103,5,101,0,0,2103,
        2104,5,120,0,0,2104,2105,5,112,0,0,2105,2106,5,111,0,0,2106,2107,
        5,115,0,0,2107,2108,5,117,0,0,2108,2109,5,114,0,0,2109,2110,5,101,
        0,0,2110,2111,5,95,0,0,2111,2112,5,101,0,0,2112,2113,5,110,0,0,2113,
        2114,5,100,0,0,2114,2115,5,95,0,0,2115,2116,5,100,0,0,2116,2117,
        5,97,0,0,2117,2118,5,116,0,0,2118,2120,5,101,0,0,2119,2073,1,0,0,
        0,2119,2097,1,0,0,0,2120,322,1,0,0,0,2121,2122,5,109,0,0,2122,2123,
        5,101,0,0,2123,2124,5,97,0,0,2124,2125,5,115,0,0,2125,2126,5,117,
        0,0,2126,2127,5,114,0,0,2127,2128,5,101,0,0,2128,2129,5,109,0,0,
        2129,2130,5,101,0,0,2130,2131,5,110,0,0,2131,2132,5,116,0,0,2132,
        2133,5,95,0,0,2133,2134,5,100,0,0,2134,2135,5,97,0,0,2135,2136,5,
        116,0,0,2136,2137,5,101,0,0,2137,324,1,0,0,0,2138,2139,5,111,0,0,
        2139,2140,5,98,0,0,2140,2141,5,115,0,0,2141,2142,5,101,0,0,2142,
        2143,5,114,0,0,2143,2144,5,118,0,0,2144,2145,5,97,0,0,2145,2146,
        5,116,0,0,2146,2147,5,105,0,0,2147,2148,5,111,0,0,2148,2149,5,110,
        0,0,2149,2150,5,95,0,0,2150,2151,5,100,0,0,2151,2152,5,97,0,0,2152,
        2153,5,116,0,0,2153,2154,5,101,0,0,2154,326,1,0,0,0,2155,2156,5,
        112,0,0,2156,2157,5,114,0,0,2157,2158,5,111,0,0,2158,2159,5,99,0,
        0,2159,2160,5,101,0,0,2160,2161,5,100,0,0,2161,2162,5,117,0,0,2162,
        2163,5,114,0,0,2163,2164,5,101,0,0,2164,2165,5,95,0,0,2165,2166,
        5,100,0,0,2166,2167,5,97,0,0,2167,2168,5,116,0,0,2168,2169,5,101,
        0,0,2169,328,1,0,0,0,2170,2171,5,118,0,0,2171,2172,5,105,0,0,2172,
        2173,5,115,0,0,2173,2174,5,105,0,0,2174,2175,5,116,0,0,2175,2176,
        5,95,0,0,2176,2177,5,115,0,0,2177,2178,5,116,0,0,2178,2179,5,97,
        0,0,2179,2180,5,114,0,0,2180,2181,5,116,0,0,2181,2182,5,95,0,0,2182,
        2183,5,100,0,0,2183,2184,5,97,0,0,2184,2185,5,116,0,0,2185,2201,
        5,101,0,0,2186,2187,5,118,0,0,2187,2188,5,105,0,0,2188,2189,5,115,
        0,0,2189,2190,5,105,0,0,2190,2191,5,116,0,0,2191,2192,5,95,0,0,2192,
        2193,5,101,0,0,2193,2194,5,110,0,0,2194,2195,5,100,0,0,2195,2196,
        5,95,0,0,2196,2197,5,100,0,0,2197,2198,5,97,0,0,2198,2199,5,116,
        0,0,2199,2201,5,101,0,0,2200,2170,1,0,0,0,2200,2186,1,0,0,0,2201,
        330,1,0,0,0,2202,2203,5,98,0,0,2203,2204,5,105,0,0,2204,2205,5,114,
        0,0,2205,2206,5,116,0,0,2206,2207,5,104,0,0,2207,2208,5,95,0,0,2208,
        2209,5,100,0,0,2209,2210,5,97,0,0,2210,2211,5,116,0,0,2211,2212,
        5,101,0,0,2212,2213,5,116,0,0,2213,2214,5,105,0,0,2214,2215,5,109,
        0,0,2215,2216,5,101,0,0,2216,332,1,0,0,0,2217,2218,5,114,0,0,2218,
        2219,5,101,0,0,2219,2220,5,102,0,0,2220,2221,5,105,0,0,2221,2222,
        5,108,0,0,2222,2223,5,108,0,0,2223,2236,5,115,0,0,2224,2225,5,100,
        0,0,2225,2226,5,97,0,0,2226,2227,5,121,0,0,2227,2228,5,115,0,0,2228,
        2229,5,95,0,0,2229,2230,5,115,0,0,2230,2231,5,117,0,0,2231,2232,
        5,112,0,0,2232,2233,5,112,0,0,2233,2234,5,108,0,0,2234,2236,5,121,
        0,0,2235,2217,1,0,0,0,2235,2224,1,0,0,0,2236,334,1,0,0,0,2237,2238,
        5,114,0,0,2238,2239,5,97,0,0,2239,2240,5,110,0,0,2240,2241,5,103,
        0,0,2241,2242,5,101,0,0,2242,2243,5,95,0,0,2243,2244,5,104,0,0,2244,
        2245,5,105,0,0,2245,2246,5,103,0,0,2246,2257,5,104,0,0,2247,2248,
        5,114,0,0,2248,2249,5,97,0,0,2249,2250,5,110,0,0,2250,2251,5,103,
        0,0,2251,2252,5,101,0,0,2252,2253,5,95,0,0,2253,2254,5,108,0,0,2254,
        2255,5,111,0,0,2255,2257,5,119,0,0,2256,2237,1,0,0,0,2256,2247,1,
        0,0,0,2257,336,1,0,0,0,2258,2259,5,121,0,0,2259,2260,5,101,0,0,2260,
        2261,5,97,0,0,2261,2262,5,114,0,0,2262,2263,5,95,0,0,2263,2264,5,
        111,0,0,2264,2265,5,102,0,0,2265,2266,5,95,0,0,2266,2267,5,98,0,
        0,2267,2268,5,105,0,0,2268,2269,5,114,0,0,2269,2270,5,116,0,0,2270,
        2310,5,104,0,0,2271,2272,5,109,0,0,2272,2273,5,111,0,0,2273,2274,
        5,110,0,0,2274,2275,5,116,0,0,2275,2276,5,104,0,0,2276,2277,5,95,
        0,0,2277,2278,5,111,0,0,2278,2279,5,102,0,0,2279,2280,5,95,0,0,2280,
        2281,5,98,0,0,2281,2282,5,105,0,0,2282,2283,5,114,0,0,2283,2284,
        5,116,0,0,2284,2310,5,104,0,0,2285,2286,5,100,0,0,2286,2287,5,97,
        0,0,2287,2288,5,121,0,0,2288,2289,5,95,0,0,2289,2290,5,111,0,0,2290,
        2291,5,102,0,0,2291,2292,5,95,0,0,2292,2293,5,98,0,0,2293,2294,5,
        105,0,0,2294,2295,5,114,0,0,2295,2296,5,116,0,0,2296,2310,5,104,
        0,0,2297,2298,5,65,0,0,2298,2299,5,71,0,0,2299,2300,5,69,0,0,2300,
        2301,5,95,0,0,2301,2302,5,65,0,0,2302,2303,5,84,0,0,2303,2304,5,
        95,0,0,2304,2305,5,73,0,0,2305,2306,5,78,0,0,2306,2307,5,68,0,0,
        2307,2308,5,69,0,0,2308,2310,5,88,0,0,2309,2258,1,0,0,0,2309,2271,
        1,0,0,0,2309,2285,1,0,0,0,2309,2297,1,0,0,0,2310,338,1,0,0,0,2311,
        2312,5,118,0,0,2312,2313,5,97,0,0,2313,2314,5,108,0,0,2314,2315,
        5,117,0,0,2315,2316,5,101,0,0,2316,2317,5,95,0,0,2317,2318,5,97,
        0,0,2318,2319,5,115,0,0,2319,2320,5,95,0,0,2320,2321,5,110,0,0,2321,
        2322,5,117,0,0,2322,2323,5,109,0,0,2323,2324,5,98,0,0,2324,2325,
        5,101,0,0,2325,2326,5,114,0,0,2326,340,1,0,0,0,2327,2328,5,113,0,
        0,2328,2329,5,117,0,0,2329,2330,5,97,0,0,2330,2331,5,110,0,0,2331,
        2332,5,116,0,0,2332,2333,5,105,0,0,2333,2334,5,116,0,0,2334,2335,
        5,121,0,0,2335,342,1,0,0,0,2336,2337,5,99,0,0,2337,2338,5,111,0,
        0,2338,2339,5,110,0,0,2339,2340,5,100,0,0,2340,2341,5,105,0,0,2341,
        2342,5,116,0,0,2342,2343,5,105,0,0,2343,2344,5,111,0,0,2344,2345,
        5,110,0,0,2345,2346,5,95,0,0,2346,2347,5,99,0,0,2347,2348,5,111,
        0,0,2348,2349,5,110,0,0,2349,2350,5,99,0,0,2350,2351,5,101,0,0,2351,
        2352,5,112,0,0,2352,2424,5,116,0,0,2353,2354,5,99,0,0,2354,2355,
        5,111,0,0,2355,2356,5,110,0,0,2356,2357,5,100,0,0,2357,2358,5,105,
        0,0,2358,2359,5,116,0,0,2359,2360,5,105,0,0,2360,2361,5,111,0,0,
        2361,2362,5,110,0,0,2362,2363,5,95,0,0,2363,2364,5,116,0,0,2364,
        2365,5,121,0,0,2365,2366,5,112,0,0,2366,2367,5,101,0,0,2367,2368,
        5,95,0,0,2368,2369,5,99,0,0,2369,2370,5,111,0,0,2370,2371,5,110,
        0,0,2371,2372,5,99,0,0,2372,2373,5,101,0,0,2373,2374,5,112,0,0,2374,
        2424,5,116,0,0,2375,2376,5,99,0,0,2376,2377,5,111,0,0,2377,2378,
        5,110,0,0,2378,2379,5,100,0,0,2379,2380,5,105,0,0,2380,2381,5,116,
        0,0,2381,2382,5,105,0,0,2382,2383,5,111,0,0,2383,2384,5,110,0,0,
        2384,2385,5,95,0,0,2385,2386,5,115,0,0,2386,2387,5,116,0,0,2387,
        2388,5,97,0,0,2388,2389,5,116,0,0,2389,2390,5,117,0,0,2390,2391,
        5,115,0,0,2391,2392,5,95,0,0,2392,2393,5,99,0,0,2393,2394,5,111,
        0,0,2394,2395,5,110,0,0,2395,2396,5,99,0,0,2396,2397,5,101,0,0,2397,
        2398,5,112,0,0,2398,2424,5,116,0,0,2399,2400,5,99,0,0,2400,2401,
        5,111,0,0,2401,2402,5,110,0,0,2402,2403,5,100,0,0,2403,2404,5,105,
        0,0,2404,2405,5,116,0,0,2405,2406,5,105,0,0,2406,2407,5,111,0,0,
        2407,2408,5,110,0,0,2408,2409,5,95,0,0,2409,2410,5,115,0,0,2410,
        2411,5,111,0,0,2411,2412,5,117,0,0,2412,2413,5,114,0,0,2413,2414,
        5,99,0,0,2414,2415,5,101,0,0,2415,2416,5,95,0,0,2416,2417,5,99,0,
        0,2417,2418,5,111,0,0,2418,2419,5,110,0,0,2419,2420,5,99,0,0,2420,
        2421,5,101,0,0,2421,2422,5,112,0,0,2422,2424,5,116,0,0,2423,2336,
        1,0,0,0,2423,2353,1,0,0,0,2423,2375,1,0,0,0,2423,2399,1,0,0,0,2424,
        344,1,0,0,0,2425,2426,5,100,0,0,2426,2427,5,114,0,0,2427,2428,5,
        117,0,0,2428,2429,5,103,0,0,2429,2430,5,95,0,0,2430,2431,5,99,0,
        0,2431,2432,5,111,0,0,2432,2433,5,110,0,0,2433,2434,5,99,0,0,2434,
        2435,5,101,0,0,2435,2436,5,112,0,0,2436,2487,5,116,0,0,2437,2438,
        5,100,0,0,2438,2439,5,114,0,0,2439,2440,5,117,0,0,2440,2441,5,103,
        0,0,2441,2442,5,95,0,0,2442,2443,5,116,0,0,2443,2444,5,121,0,0,2444,
        2445,5,112,0,0,2445,2446,5,101,0,0,2446,2447,5,95,0,0,2447,2448,
        5,99,0,0,2448,2449,5,111,0,0,2449,2450,5,110,0,0,2450,2451,5,99,
        0,0,2451,2452,5,101,0,0,2452,2453,5,112,0,0,2453,2487,5,116,0,0,
        2454,2455,5,114,0,0,2455,2456,5,111,0,0,2456,2457,5,117,0,0,2457,
        2458,5,116,0,0,2458,2459,5,101,0,0,2459,2460,5,95,0,0,2460,2461,
        5,99,0,0,2461,2462,5,111,0,0,2462,2463,5,110,0,0,2463,2464,5,99,
        0,0,2464,2465,5,101,0,0,2465,2466,5,112,0,0,2466,2487,5,116,0,0,
        2467,2468,5,100,0,0,2468,2469,5,114,0,0,2469,2470,5,117,0,0,2470,
        2471,5,103,0,0,2471,2472,5,95,0,0,2472,2473,5,115,0,0,2473,2474,
        5,111,0,0,2474,2475,5,117,0,0,2475,2476,5,114,0,0,2476,2477,5,99,
        0,0,2477,2478,5,101,0,0,2478,2479,5,95,0,0,2479,2480,5,99,0,0,2480,
        2481,5,111,0,0,2481,2482,5,110,0,0,2482,2483,5,99,0,0,2483,2484,
        5,101,0,0,2484,2485,5,112,0,0,2485,2487,5,116,0,0,2486,2425,1,0,
        0,0,2486,2437,1,0,0,0,2486,2454,1,0,0,0,2486,2467,1,0,0,0,2487,346,
        1,0,0,0,2488,2489,5,109,0,0,2489,2490,5,101,0,0,2490,2491,5,97,0,
        0,2491,2492,5,115,0,0,2492,2493,5,117,0,0,2493,2494,5,114,0,0,2494,
        2495,5,101,0,0,2495,2496,5,109,0,0,2496,2497,5,101,0,0,2497,2498,
        5,110,0,0,2498,2499,5,116,0,0,2499,2500,5,95,0,0,2500,2501,5,99,
        0,0,2501,2502,5,111,0,0,2502,2503,5,110,0,0,2503,2504,5,99,0,0,2504,
        2505,5,101,0,0,2505,2506,5,112,0,0,2506,2577,5,116,0,0,2507,2508,
        5,109,0,0,2508,2509,5,101,0,0,2509,2510,5,97,0,0,2510,2511,5,115,
        0,0,2511,2512,5,117,0,0,2512,2513,5,114,0,0,2513,2514,5,101,0,0,
        2514,2515,5,109,0,0,2515,2516,5,101,0,0,2516,2517,5,110,0,0,2517,
        2518,5,116,0,0,2518,2519,5,95,0,0,2519,2520,5,115,0,0,2520,2521,
        5,111,0,0,2521,2522,5,117,0,0,2522,2523,5,114,0,0,2523,2524,5,99,
        0,0,2524,2525,5,101,0,0,2525,2526,5,95,0,0,2526,2527,5,99,0,0,2527,
        2528,5,111,0,0,2528,2529,5,110,0,0,2529,2530,5,99,0,0,2530,2531,
        5,101,0,0,2531,2532,5,112,0,0,2532,2577,5,116,0,0,2533,2534,5,109,
        0,0,2534,2535,5,101,0,0,2535,2536,5,97,0,0,2536,2537,5,115,0,0,2537,
        2538,5,117,0,0,2538,2539,5,114,0,0,2539,2540,5,101,0,0,2540,2541,
        5,109,0,0,2541,2542,5,101,0,0,2542,2543,5,110,0,0,2543,2544,5,116,
        0,0,2544,2545,5,95,0,0,2545,2546,5,116,0,0,2546,2547,5,121,0,0,2547,
        2548,5,112,0,0,2548,2549,5,101,0,0,2549,2550,5,95,0,0,2550,2551,
        5,99,0,0,2551,2552,5,111,0,0,2552,2553,5,110,0,0,2553,2554,5,99,
        0,0,2554,2555,5,101,0,0,2555,2556,5,112,0,0,2556,2577,5,116,0,0,
        2557,2558,5,117,0,0,2558,2559,5,110,0,0,2559,2560,5,105,0,0,2560,
        2561,5,116,0,0,2561,2562,5,95,0,0,2562,2563,5,115,0,0,2563,2564,
        5,111,0,0,2564,2565,5,117,0,0,2565,2566,5,114,0,0,2566,2567,5,99,
        0,0,2567,2568,5,101,0,0,2568,2569,5,95,0,0,2569,2570,5,99,0,0,2570,
        2571,5,111,0,0,2571,2572,5,110,0,0,2572,2573,5,99,0,0,2573,2574,
        5,101,0,0,2574,2575,5,112,0,0,2575,2577,5,116,0,0,2576,2488,1,0,
        0,0,2576,2507,1,0,0,0,2576,2533,1,0,0,0,2576,2557,1,0,0,0,2577,348,
        1,0,0,0,2578,2579,5,111,0,0,2579,2580,5,98,0,0,2580,2581,5,115,0,
        0,2581,2582,5,101,0,0,2582,2583,5,114,0,0,2583,2584,5,118,0,0,2584,
        2585,5,97,0,0,2585,2586,5,116,0,0,2586,2587,5,105,0,0,2587,2588,
        5,111,0,0,2588,2589,5,110,0,0,2589,2590,5,95,0,0,2590,2591,5,99,
        0,0,2591,2592,5,111,0,0,2592,2593,5,110,0,0,2593,2594,5,99,0,0,2594,
        2595,5,101,0,0,2595,2596,5,112,0,0,2596,2622,5,116,0,0,2597,2598,
        5,111,0,0,2598,2599,5,98,0,0,2599,2600,5,115,0,0,2600,2601,5,101,
        0,0,2601,2602,5,114,0,0,2602,2603,5,118,0,0,2603,2604,5,97,0,0,2604,
        2605,5,116,0,0,2605,2606,5,105,0,0,2606,2607,5,111,0,0,2607,2608,
        5,110,0,0,2608,2609,5,95,0,0,2609,2610,5,116,0,0,2610,2611,5,121,
        0,0,2611,2612,5,112,0,0,2612,2613,5,101,0,0,2613,2614,5,95,0,0,2614,
        2615,5,99,0,0,2615,2616,5,111,0,0,2616,2617,5,110,0,0,2617,2618,
        5,99,0,0,2618,2619,5,101,0,0,2619,2620,5,112,0,0,2620,2622,5,116,
        0,0,2621,2578,1,0,0,0,2621,2597,1,0,0,0,2622,350,1,0,0,0,2623,2624,
        5,103,0,0,2624,2625,5,101,0,0,2625,2626,5,110,0,0,2626,2627,5,100,
        0,0,2627,2628,5,101,0,0,2628,2629,5,114,0,0,2629,2630,5,95,0,0,2630,
        2631,5,99,0,0,2631,2632,5,111,0,0,2632,2633,5,110,0,0,2633,2634,
        5,99,0,0,2634,2635,5,101,0,0,2635,2636,5,112,0,0,2636,2667,5,116,
        0,0,2637,2638,5,114,0,0,2638,2639,5,97,0,0,2639,2640,5,99,0,0,2640,
        2641,5,101,0,0,2641,2642,5,95,0,0,2642,2643,5,99,0,0,2643,2644,5,
        111,0,0,2644,2645,5,110,0,0,2645,2646,5,99,0,0,2646,2647,5,101,0,
        0,2647,2648,5,112,0,0,2648,2667,5,116,0,0,2649,2650,5,101,0,0,2650,
        2651,5,116,0,0,2651,2652,5,104,0,0,2652,2653,5,110,0,0,2653,2654,
        5,105,0,0,2654,2655,5,99,0,0,2655,2656,5,105,0,0,2656,2657,5,116,
        0,0,2657,2658,5,121,0,0,2658,2659,5,95,0,0,2659,2660,5,99,0,0,2660,
        2661,5,111,0,0,2661,2662,5,110,0,0,2662,2663,5,99,0,0,2663,2664,
        5,101,0,0,2664,2665,5,112,0,0,2665,2667,5,116,0,0,2666,2623,1,0,
        0,0,2666,2637,1,0,0,0,2666,2649,1,0,0,0,2667,352,1,0,0,0,2668,2669,
        5,112,0,0,2669,2670,5,114,0,0,2670,2671,5,111,0,0,2671,2672,5,99,
        0,0,2672,2673,5,101,0,0,2673,2674,5,100,0,0,2674,2675,5,117,0,0,
        2675,2676,5,114,0,0,2676,2677,5,101,0,0,2677,2678,5,95,0,0,2678,
        2679,5,99,0,0,2679,2680,5,111,0,0,2680,2681,5,110,0,0,2681,2682,
        5,99,0,0,2682,2683,5,101,0,0,2683,2684,5,112,0,0,2684,2724,5,116,
        0,0,2685,2686,5,112,0,0,2686,2687,5,114,0,0,2687,2688,5,111,0,0,
        2688,2689,5,99,0,0,2689,2690,5,101,0,0,2690,2691,5,100,0,0,2691,
        2692,5,117,0,0,2692,2693,5,114,0,0,2693,2694,5,101,0,0,2694,2695,
        5,95,0,0,2695,2696,5,116,0,0,2696,2697,5,121,0,0,2697,2698,5,112,
        0,0,2698,2699,5,101,0,0,2699,2700,5,95,0,0,2700,2701,5,99,0,0,2701,
        2702,5,111,0,0,2702,2703,5,110,0,0,2703,2704,5,99,0,0,2704,2705,
        5,101,0,0,2705,2706,5,112,0,0,2706,2724,5,116,0,0,2707,2708,5,109,
        0,0,2708,2709,5,111,0,0,2709,2710,5,100,0,0,2710,2711,5,105,0,0,
        2711,2712,5,102,0,0,2712,2713,5,105,0,0,2713,2714,5,101,0,0,2714,
        2715,5,114,0,0,2715,2716,5,95,0,0,2716,2717,5,99,0,0,2717,2718,5,
        111,0,0,2718,2719,5,110,0,0,2719,2720,5,99,0,0,2720,2721,5,101,0,
        0,2721,2722,5,112,0,0,2722,2724,5,116,0,0,2723,2668,1,0,0,0,2723,
        2685,1,0,0,0,2723,2707,1,0,0,0,2724,354,1,0,0,0,2725,2726,5,115,
        0,0,2726,2727,5,112,0,0,2727,2728,5,101,0,0,2728,2729,5,99,0,0,2729,
        2730,5,105,0,0,2730,2731,5,97,0,0,2731,2732,5,108,0,0,2732,2733,
        5,116,0,0,2733,2734,5,121,0,0,2734,2735,5,95,0,0,2735,2736,5,99,
        0,0,2736,2737,5,111,0,0,2737,2738,5,110,0,0,2738,2739,5,99,0,0,2739,
        2740,5,101,0,0,2740,2741,5,112,0,0,2741,2742,5,116,0,0,2742,356,
        1,0,0,0,2743,2744,5,118,0,0,2744,2745,5,105,0,0,2745,2746,5,115,
        0,0,2746,2747,5,105,0,0,2747,2748,5,116,0,0,2748,2749,5,95,0,0,2749,
        2750,5,99,0,0,2750,2751,5,111,0,0,2751,2752,5,110,0,0,2752,2753,
        5,99,0,0,2753,2754,5,101,0,0,2754,2755,5,112,0,0,2755,2795,5,116,
        0,0,2756,2757,5,118,0,0,2757,2758,5,105,0,0,2758,2759,5,115,0,0,
        2759,2760,5,105,0,0,2760,2761,5,116,0,0,2761,2762,5,95,0,0,2762,
        2763,5,115,0,0,2763,2764,5,111,0,0,2764,2765,5,117,0,0,2765,2766,
        5,114,0,0,2766,2767,5,99,0,0,2767,2768,5,101,0,0,2768,2769,5,95,
        0,0,2769,2770,5,99,0,0,2770,2771,5,111,0,0,2771,2772,5,110,0,0,2772,
        2773,5,99,0,0,2773,2774,5,101,0,0,2774,2775,5,112,0,0,2775,2795,
        5,116,0,0,2776,2777,5,118,0,0,2777,2778,5,105,0,0,2778,2779,5,115,
        0,0,2779,2780,5,105,0,0,2780,2781,5,116,0,0,2781,2782,5,95,0,0,2782,
        2783,5,116,0,0,2783,2784,5,121,0,0,2784,2785,5,112,0,0,2785,2786,
        5,101,0,0,2786,2787,5,95,0,0,2787,2788,5,99,0,0,2788,2789,5,111,
        0,0,2789,2790,5,110,0,0,2790,2791,5,99,0,0,2791,2792,5,101,0,0,2792,
        2793,5,112,0,0,2793,2795,5,116,0,0,2794,2743,1,0,0,0,2794,2756,1,
        0,0,0,2794,2776,1,0,0,0,2795,358,1,0,0,0,2796,2797,5,118,0,0,2797,
        2798,5,97,0,0,2798,2799,5,108,0,0,2799,2800,5,117,0,0,2800,2801,
        5,101,0,0,2801,2802,5,95,0,0,2802,2803,5,97,0,0,2803,2804,5,115,
        0,0,2804,2805,5,95,0,0,2805,2806,5,99,0,0,2806,2807,5,111,0,0,2807,
        2808,5,110,0,0,2808,2809,5,99,0,0,2809,2810,5,101,0,0,2810,2811,
        5,112,0,0,2811,2825,5,116,0,0,2812,2813,5,117,0,0,2813,2814,5,110,
        0,0,2814,2815,5,105,0,0,2815,2816,5,116,0,0,2816,2817,5,95,0,0,2817,
        2818,5,99,0,0,2818,2819,5,111,0,0,2819,2820,5,110,0,0,2820,2821,
        5,99,0,0,2821,2822,5,101,0,0,2822,2823,5,112,0,0,2823,2825,5,116,
        0,0,2824,2796,1,0,0,0,2824,2812,1,0,0,0,2825,360,1,0,0,0,2826,2827,
        5,112,0,0,2827,2828,5,108,0,0,2828,2829,5,97,0,0,2829,2830,5,99,
        0,0,2830,2831,5,101,0,0,2831,2832,5,95,0,0,2832,2833,5,111,0,0,2833,
        2834,5,102,0,0,2834,2835,5,95,0,0,2835,2836,5,115,0,0,2836,2837,
        5,101,0,0,2837,2838,5,114,0,0,2838,2839,5,118,0,0,2839,2840,5,105,
        0,0,2840,2841,5,99,0,0,2841,2842,5,101,0,0,2842,2843,5,95,0,0,2843,
        2844,5,99,0,0,2844,2845,5,111,0,0,2845,2846,5,110,0,0,2846,2847,
        5,99,0,0,2847,2848,5,101,0,0,2848,2849,5,112,0,0,2849,2850,5,116,
        0,0,2850,362,1,0,0,0,2851,2852,5,118,0,0,2852,2853,5,97,0,0,2853,
        2854,5,108,0,0,2854,2855,5,117,0,0,2855,2856,5,101,0,0,2856,2857,
        5,95,0,0,2857,2858,5,97,0,0,2858,2859,5,115,0,0,2859,2860,5,95,0,
        0,2860,2861,5,115,0,0,2861,2862,5,116,0,0,2862,2863,5,114,0,0,2863,
        2864,5,105,0,0,2864,2865,5,110,0,0,2865,2866,5,103,0,0,2866,364,
        1,0,0,0,2867,2868,5,103,0,0,2868,2869,5,101,0,0,2869,2870,5,110,
        0,0,2870,2871,5,100,0,0,2871,2872,5,101,0,0,2872,2873,5,114,0,0,
        2873,2874,5,95,0,0,2874,2875,5,115,0,0,2875,2876,5,111,0,0,2876,
        2877,5,117,0,0,2877,2878,5,114,0,0,2878,2879,5,99,0,0,2879,2880,
        5,101,0,0,2880,2881,5,95,0,0,2881,2882,5,118,0,0,2882,2883,5,97,
        0,0,2883,2884,5,108,0,0,2884,2885,5,117,0,0,2885,2886,5,101,0,0,
        2886,366,1,0,0,0,2887,2888,5,99,0,0,2888,2889,5,97,0,0,2889,2890,
        5,114,0,0,2890,2891,5,101,0,0,2891,2892,5,95,0,0,2892,2893,5,115,
        0,0,2893,2894,5,105,0,0,2894,2895,5,116,0,0,2895,2896,5,101,0,0,
        2896,2897,5,95,0,0,2897,2898,5,110,0,0,2898,2899,5,97,0,0,2899,2900,
        5,109,0,0,2900,2953,5,101,0,0,2901,2902,5,99,0,0,2902,2903,5,97,
        0,0,2903,2904,5,114,0,0,2904,2905,5,101,0,0,2905,2906,5,95,0,0,2906,
        2907,5,115,0,0,2907,2908,5,105,0,0,2908,2909,5,116,0,0,2909,2910,
        5,101,0,0,2910,2911,5,95,0,0,2911,2912,5,115,0,0,2912,2913,5,111,
        0,0,2913,2914,5,117,0,0,2914,2915,5,114,0,0,2915,2916,5,99,0,0,2916,
        2917,5,101,0,0,2917,2918,5,95,0,0,2918,2919,5,118,0,0,2919,2920,
        5,97,0,0,2920,2921,5,108,0,0,2921,2922,5,117,0,0,2922,2953,5,101,
        0,0,2923,2924,5,112,0,0,2924,2925,5,108,0,0,2925,2926,5,97,0,0,2926,
        2927,5,99,0,0,2927,2928,5,101,0,0,2928,2929,5,95,0,0,2929,2930,5,
        111,0,0,2930,2931,5,102,0,0,2931,2932,5,95,0,0,2932,2933,5,115,0,
        0,2933,2934,5,101,0,0,2934,2935,5,114,0,0,2935,2936,5,118,0,0,2936,
        2937,5,105,0,0,2937,2938,5,99,0,0,2938,2939,5,101,0,0,2939,2940,
        5,95,0,0,2940,2941,5,115,0,0,2941,2942,5,111,0,0,2942,2943,5,117,
        0,0,2943,2944,5,114,0,0,2944,2945,5,99,0,0,2945,2946,5,101,0,0,2946,
        2947,5,95,0,0,2947,2948,5,118,0,0,2948,2949,5,97,0,0,2949,2950,5,
        108,0,0,2950,2951,5,117,0,0,2951,2953,5,101,0,0,2952,2887,1,0,0,
        0,2952,2901,1,0,0,0,2952,2923,1,0,0,0,2953,368,1,0,0,0,2954,2955,
        5,99,0,0,2955,2956,5,111,0,0,2956,2957,5,110,0,0,2957,2958,5,100,
        0,0,2958,2959,5,105,0,0,2959,2960,5,116,0,0,2960,2961,5,105,0,0,
        2961,2962,5,111,0,0,2962,2963,5,110,0,0,2963,2964,5,95,0,0,2964,
        2965,5,111,0,0,2965,2966,5,99,0,0,2966,2967,5,99,0,0,2967,2968,5,
        117,0,0,2968,2969,5,114,0,0,2969,2970,5,114,0,0,2970,2971,5,101,
        0,0,2971,2972,5,110,0,0,2972,2973,5,99,0,0,2973,2974,5,101,0,0,2974,
        2975,5,95,0,0,2975,2976,5,115,0,0,2976,2977,5,116,0,0,2977,2978,
        5,111,0,0,2978,2979,5,112,0,0,2979,2980,5,95,0,0,2980,2981,5,114,
        0,0,2981,2982,5,101,0,0,2982,2983,5,97,0,0,2983,2984,5,115,0,0,2984,
        2985,5,111,0,0,2985,3038,5,110,0,0,2986,2987,5,99,0,0,2987,2988,
        5,111,0,0,2988,2989,5,110,0,0,2989,2990,5,100,0,0,2990,2991,5,105,
        0,0,2991,2992,5,116,0,0,2992,2993,5,105,0,0,2993,2994,5,111,0,0,
        2994,2995,5,110,0,0,2995,2996,5,95,0,0,2996,2997,5,115,0,0,2997,
        2998,5,111,0,0,2998,2999,5,117,0,0,2999,3000,5,114,0,0,3000,3001,
        5,99,0,0,3001,3002,5,101,0,0,3002,3003,5,95,0,0,3003,3004,5,118,
        0,0,3004,3005,5,97,0,0,3005,3006,5,108,0,0,3006,3007,5,117,0,0,3007,
        3038,5,101,0,0,3008,3009,5,99,0,0,3009,3010,5,111,0,0,3010,3011,
        5,110,0,0,3011,3012,5,100,0,0,3012,3013,5,105,0,0,3013,3014,5,116,
        0,0,3014,3015,5,105,0,0,3015,3016,5,111,0,0,3016,3017,5,110,0,0,
        3017,3018,5,95,0,0,3018,3019,5,115,0,0,3019,3020,5,116,0,0,3020,
        3021,5,97,0,0,3021,3022,5,116,0,0,3022,3023,5,117,0,0,3023,3024,
        5,115,0,0,3024,3025,5,95,0,0,3025,3026,5,115,0,0,3026,3027,5,111,
        0,0,3027,3028,5,117,0,0,3028,3029,5,114,0,0,3029,3030,5,99,0,0,3030,
        3031,5,101,0,0,3031,3032,5,95,0,0,3032,3033,5,118,0,0,3033,3034,
        5,97,0,0,3034,3035,5,108,0,0,3035,3036,5,117,0,0,3036,3038,5,101,
        0,0,3037,2954,1,0,0,0,3037,2986,1,0,0,0,3037,3008,1,0,0,0,3038,370,
        1,0,0,0,3039,3040,5,100,0,0,3040,3041,5,114,0,0,3041,3042,5,117,
        0,0,3042,3043,5,103,0,0,3043,3044,5,95,0,0,3044,3045,5,101,0,0,3045,
        3046,5,120,0,0,3046,3047,5,112,0,0,3047,3048,5,111,0,0,3048,3049,
        5,115,0,0,3049,3050,5,117,0,0,3050,3051,5,114,0,0,3051,3052,5,101,
        0,0,3052,3053,5,95,0,0,3053,3054,5,115,0,0,3054,3055,5,116,0,0,3055,
        3056,5,111,0,0,3056,3057,5,112,0,0,3057,3058,5,95,0,0,3058,3059,
        5,114,0,0,3059,3060,5,101,0,0,3060,3061,5,97,0,0,3061,3062,5,115,
        0,0,3062,3063,5,111,0,0,3063,3135,5,110,0,0,3064,3065,5,115,0,0,
        3065,3066,5,105,0,0,3066,3135,5,103,0,0,3067,3068,5,108,0,0,3068,
        3069,5,111,0,0,3069,3070,5,116,0,0,3070,3071,5,95,0,0,3071,3072,
        5,110,0,0,3072,3073,5,117,0,0,3073,3074,5,109,0,0,3074,3075,5,98,
        0,0,3075,3076,5,101,0,0,3076,3135,5,114,0,0,3077,3078,5,100,0,0,
        3078,3079,5,114,0,0,3079,3080,5,117,0,0,3080,3081,5,103,0,0,3081,
        3082,5,95,0,0,3082,3083,5,115,0,0,3083,3084,5,111,0,0,3084,3085,
        5,117,0,0,3085,3086,5,114,0,0,3086,3087,5,99,0,0,3087,3088,5,101,
        0,0,3088,3089,5,95,0,0,3089,3090,5,118,0,0,3090,3091,5,97,0,0,3091,
        3092,5,108,0,0,3092,3093,5,117,0,0,3093,3135,5,101,0,0,3094,3095,
        5,114,0,0,3095,3096,5,111,0,0,3096,3097,5,117,0,0,3097,3098,5,116,
        0,0,3098,3099,5,101,0,0,3099,3100,5,95,0,0,3100,3101,5,115,0,0,3101,
        3102,5,111,0,0,3102,3103,5,117,0,0,3103,3104,5,114,0,0,3104,3105,
        5,99,0,0,3105,3106,5,101,0,0,3106,3107,5,95,0,0,3107,3108,5,118,
        0,0,3108,3109,5,97,0,0,3109,3110,5,108,0,0,3110,3111,5,117,0,0,3111,
        3135,5,101,0,0,3112,3113,5,100,0,0,3113,3114,5,111,0,0,3114,3115,
        5,115,0,0,3115,3116,5,101,0,0,3116,3117,5,95,0,0,3117,3118,5,117,
        0,0,3118,3119,5,110,0,0,3119,3120,5,105,0,0,3120,3121,5,116,0,0,
        3121,3122,5,95,0,0,3122,3123,5,115,0,0,3123,3124,5,111,0,0,3124,
        3125,5,117,0,0,3125,3126,5,114,0,0,3126,3127,5,99,0,0,3127,3128,
        5,101,0,0,3128,3129,5,95,0,0,3129,3130,5,118,0,0,3130,3131,5,97,
        0,0,3131,3132,5,108,0,0,3132,3133,5,117,0,0,3133,3135,5,101,0,0,
        3134,3039,1,0,0,0,3134,3064,1,0,0,0,3134,3067,1,0,0,0,3134,3077,
        1,0,0,0,3134,3094,1,0,0,0,3134,3112,1,0,0,0,3135,372,1,0,0,0,3136,
        3137,5,109,0,0,3137,3138,5,101,0,0,3138,3139,5,97,0,0,3139,3140,
        5,115,0,0,3140,3141,5,117,0,0,3141,3142,5,114,0,0,3142,3143,5,101,
        0,0,3143,3144,5,109,0,0,3144,3145,5,101,0,0,3145,3146,5,110,0,0,
        3146,3147,5,116,0,0,3147,3148,5,95,0,0,3148,3149,5,116,0,0,3149,
        3150,5,105,0,0,3150,3151,5,109,0,0,3151,3212,5,101,0,0,3152,3153,
        5,109,0,0,3153,3154,5,101,0,0,3154,3155,5,97,0,0,3155,3156,5,115,
        0,0,3156,3157,5,117,0,0,3157,3158,5,114,0,0,3158,3159,5,101,0,0,
        3159,3160,5,109,0,0,3160,3161,5,101,0,0,3161,3162,5,110,0,0,3162,
        3163,5,116,0,0,3163,3164,5,95,0,0,3164,3165,5,115,0,0,3165,3166,
        5,111,0,0,3166,3167,5,117,0,0,3167,3168,5,114,0,0,3168,3169,5,99,
        0,0,3169,3170,5,101,0,0,3170,3171,5,95,0,0,3171,3172,5,118,0,0,3172,
        3173,5,97,0,0,3173,3174,5,108,0,0,3174,3175,5,117,0,0,3175,3212,
        5,101,0,0,3176,3177,5,117,0,0,3177,3178,5,110,0,0,3178,3179,5,105,
        0,0,3179,3180,5,116,0,0,3180,3181,5,95,0,0,3181,3182,5,115,0,0,3182,
        3183,5,111,0,0,3183,3184,5,117,0,0,3184,3185,5,114,0,0,3185,3186,
        5,99,0,0,3186,3187,5,101,0,0,3187,3188,5,95,0,0,3188,3189,5,118,
        0,0,3189,3190,5,97,0,0,3190,3191,5,108,0,0,3191,3192,5,117,0,0,3192,
        3212,5,101,0,0,3193,3194,5,118,0,0,3194,3195,5,97,0,0,3195,3196,
        5,108,0,0,3196,3197,5,117,0,0,3197,3198,5,101,0,0,3198,3199,5,95,
        0,0,3199,3200,5,115,0,0,3200,3201,5,111,0,0,3201,3202,5,117,0,0,
        3202,3203,5,114,0,0,3203,3204,5,99,0,0,3204,3205,5,101,0,0,3205,
        3206,5,95,0,0,3206,3207,5,118,0,0,3207,3208,5,97,0,0,3208,3209,5,
        108,0,0,3209,3210,5,117,0,0,3210,3212,5,101,0,0,3211,3136,1,0,0,
        0,3211,3152,1,0,0,0,3211,3176,1,0,0,0,3211,3193,1,0,0,0,3212,374,
        1,0,0,0,3213,3214,3,363,181,0,3214,376,1,0,0,0,3215,3216,5,112,0,
        0,3216,3217,5,101,0,0,3217,3218,5,114,0,0,3218,3219,5,115,0,0,3219,
        3220,5,111,0,0,3220,3221,5,110,0,0,3221,3222,5,95,0,0,3222,3223,
        5,115,0,0,3223,3224,5,111,0,0,3224,3225,5,117,0,0,3225,3226,5,114,
        0,0,3226,3227,5,99,0,0,3227,3228,5,101,0,0,3228,3229,5,95,0,0,3229,
        3230,5,118,0,0,3230,3231,5,97,0,0,3231,3232,5,108,0,0,3232,3233,
        5,117,0,0,3233,3275,5,101,0,0,3234,3275,3,365,182,0,3235,3236,5,
        114,0,0,3236,3237,5,97,0,0,3237,3238,5,99,0,0,3238,3239,5,101,0,
        0,3239,3240,5,95,0,0,3240,3241,5,115,0,0,3241,3242,5,111,0,0,3242,
        3243,5,117,0,0,3243,3244,5,114,0,0,3244,3245,5,99,0,0,3245,3246,
        5,101,0,0,3246,3247,5,95,0,0,3247,3248,5,118,0,0,3248,3249,5,97,
        0,0,3249,3250,5,108,0,0,3250,3251,5,117,0,0,3251,3275,5,101,0,0,
        3252,3253,5,101,0,0,3253,3254,5,116,0,0,3254,3255,5,104,0,0,3255,
        3256,5,110,0,0,3256,3257,5,105,0,0,3257,3258,5,99,0,0,3258,3259,
        5,105,0,0,3259,3260,5,116,0,0,3260,3261,5,121,0,0,3261,3262,5,95,
        0,0,3262,3263,5,115,0,0,3263,3264,5,111,0,0,3264,3265,5,117,0,0,
        3265,3266,5,114,0,0,3266,3267,5,99,0,0,3267,3268,5,101,0,0,3268,
        3269,5,95,0,0,3269,3270,5,118,0,0,3270,3271,5,97,0,0,3271,3272,5,
        108,0,0,3272,3273,5,117,0,0,3273,3275,5,101,0,0,3274,3215,1,0,0,
        0,3274,3234,1,0,0,0,3274,3235,1,0,0,0,3274,3252,1,0,0,0,3275,378,
        1,0,0,0,3276,3277,5,112,0,0,3277,3278,5,114,0,0,3278,3279,5,111,
        0,0,3279,3280,5,99,0,0,3280,3281,5,101,0,0,3281,3282,5,100,0,0,3282,
        3283,5,117,0,0,3283,3284,5,114,0,0,3284,3285,5,101,0,0,3285,3286,
        5,95,0,0,3286,3287,5,115,0,0,3287,3288,5,111,0,0,3288,3289,5,117,
        0,0,3289,3290,5,114,0,0,3290,3291,5,99,0,0,3291,3292,5,101,0,0,3292,
        3293,5,95,0,0,3293,3294,5,118,0,0,3294,3295,5,97,0,0,3295,3296,5,
        108,0,0,3296,3297,5,117,0,0,3297,3320,5,101,0,0,3298,3299,5,109,
        0,0,3299,3300,5,111,0,0,3300,3301,5,100,0,0,3301,3302,5,105,0,0,
        3302,3303,5,102,0,0,3303,3304,5,105,0,0,3304,3305,5,101,0,0,3305,
        3306,5,114,0,0,3306,3307,5,95,0,0,3307,3308,5,115,0,0,3308,3309,
        5,111,0,0,3309,3310,5,117,0,0,3310,3311,5,114,0,0,3311,3312,5,99,
        0,0,3312,3313,5,101,0,0,3313,3314,5,95,0,0,3314,3315,5,118,0,0,3315,
        3316,5,97,0,0,3316,3317,5,108,0,0,3317,3318,5,117,0,0,3318,3320,
        5,101,0,0,3319,3276,1,0,0,0,3319,3298,1,0,0,0,3320,380,1,0,0,0,3321,
        3322,5,112,0,0,3322,3323,5,114,0,0,3323,3324,5,111,0,0,3324,3325,
        5,118,0,0,3325,3326,5,105,0,0,3326,3327,5,100,0,0,3327,3328,5,101,
        0,0,3328,3329,5,114,0,0,3329,3330,5,95,0,0,3330,3331,5,110,0,0,3331,
        3332,5,97,0,0,3332,3333,5,109,0,0,3333,3385,5,101,0,0,3334,3335,
        5,110,0,0,3335,3336,5,112,0,0,3336,3385,5,105,0,0,3337,3338,5,100,
        0,0,3338,3339,5,101,0,0,3339,3385,5,97,0,0,3340,3341,5,112,0,0,3341,
        3342,5,114,0,0,3342,3343,5,111,0,0,3343,3344,5,118,0,0,3344,3345,
        5,105,0,0,3345,3346,5,100,0,0,3346,3347,5,101,0,0,3347,3348,5,114,
        0,0,3348,3349,5,95,0,0,3349,3350,5,115,0,0,3350,3351,5,111,0,0,3351,
        3352,5,117,0,0,3352,3353,5,114,0,0,3353,3354,5,99,0,0,3354,3355,
        5,101,0,0,3355,3356,5,95,0,0,3356,3357,5,118,0,0,3357,3358,5,97,
        0,0,3358,3359,5,108,0,0,3359,3360,5,117,0,0,3360,3385,5,101,0,0,
        3361,3362,5,115,0,0,3362,3363,5,112,0,0,3363,3364,5,101,0,0,3364,
        3365,5,99,0,0,3365,3366,5,105,0,0,3366,3367,5,97,0,0,3367,3368,5,
        108,0,0,3368,3369,5,116,0,0,3369,3370,5,121,0,0,3370,3371,5,95,0,
        0,3371,3372,5,115,0,0,3372,3373,5,111,0,0,3373,3374,5,117,0,0,3374,
        3375,5,114,0,0,3375,3376,5,99,0,0,3376,3377,5,101,0,0,3377,3378,
        5,95,0,0,3378,3379,5,118,0,0,3379,3380,5,97,0,0,3380,3381,5,108,
        0,0,3381,3382,5,117,0,0,3382,3385,5,101,0,0,3383,3385,3,365,182,
        0,3384,3321,1,0,0,0,3384,3334,1,0,0,0,3384,3337,1,0,0,0,3384,3340,
        1,0,0,0,3384,3361,1,0,0,0,3384,3383,1,0,0,0,3385,382,1,0,0,0,3386,
        3387,5,118,0,0,3387,3388,5,105,0,0,3388,3389,5,115,0,0,3389,3390,
        5,105,0,0,3390,3391,5,116,0,0,3391,3392,5,95,0,0,3392,3393,5,115,
        0,0,3393,3394,5,111,0,0,3394,3395,5,117,0,0,3395,3396,5,114,0,0,
        3396,3397,5,99,0,0,3397,3398,5,101,0,0,3398,3399,5,95,0,0,3399,3400,
        5,118,0,0,3400,3401,5,97,0,0,3401,3402,5,108,0,0,3402,3403,5,117,
        0,0,3403,3457,5,101,0,0,3404,3405,5,97,0,0,3405,3406,5,100,0,0,3406,
        3407,5,109,0,0,3407,3408,5,105,0,0,3408,3409,5,116,0,0,3409,3410,
        5,116,0,0,3410,3411,5,101,0,0,3411,3412,5,100,0,0,3412,3413,5,95,
        0,0,3413,3414,5,102,0,0,3414,3415,5,114,0,0,3415,3416,5,111,0,0,
        3416,3417,5,109,0,0,3417,3418,5,95,0,0,3418,3419,5,115,0,0,3419,
        3420,5,111,0,0,3420,3421,5,117,0,0,3421,3422,5,114,0,0,3422,3423,
        5,99,0,0,3423,3424,5,101,0,0,3424,3425,5,95,0,0,3425,3426,5,118,
        0,0,3426,3427,5,97,0,0,3427,3428,5,108,0,0,3428,3429,5,117,0,0,3429,
        3457,5,101,0,0,3430,3431,5,100,0,0,3431,3432,5,105,0,0,3432,3433,
        5,115,0,0,3433,3434,5,99,0,0,3434,3435,5,104,0,0,3435,3436,5,97,
        0,0,3436,3437,5,114,0,0,3437,3438,5,103,0,0,3438,3439,5,101,0,0,
        3439,3440,5,100,0,0,3440,3441,5,95,0,0,3441,3442,5,116,0,0,3442,
        3443,5,111,0,0,3443,3444,5,95,0,0,3444,3445,5,115,0,0,3445,3446,
        5,111,0,0,3446,3447,5,117,0,0,3447,3448,5,114,0,0,3448,3449,5,99,
        0,0,3449,3450,5,101,0,0,3450,3451,5,95,0,0,3451,3452,5,118,0,0,3452,
        3453,5,97,0,0,3453,3454,5,108,0,0,3454,3455,5,117,0,0,3455,3457,
        5,101,0,0,3456,3386,1,0,0,0,3456,3404,1,0,0,0,3456,3430,1,0,0,0,
        3457,384,1,0,0,0,41,0,555,591,613,635,656,681,747,787,885,891,1123,
        1131,1137,1145,1170,1172,1180,1417,2071,2119,2200,2235,2256,2309,
        2423,2486,2576,2621,2666,2723,2794,2824,2952,3037,3134,3211,3274,
        3319,3384,3456,1,6,0,0
    ];

    private static __ATN: antlr.ATN;
    public static get _ATN(): antlr.ATN {
        if (!CohortDefinitionLexer.__ATN) {
            CohortDefinitionLexer.__ATN = new antlr.ATNDeserializer().deserialize(CohortDefinitionLexer._serializedATN);
        }

        return CohortDefinitionLexer.__ATN;
    }


    private static readonly vocabulary = new antlr.Vocabulary(CohortDefinitionLexer.literalNames, CohortDefinitionLexer.symbolicNames, []);

    public override get vocabulary(): antlr.Vocabulary {
        return CohortDefinitionLexer.vocabulary;
    }

    private static readonly decisionsToDFA = CohortDefinitionLexer._ATN.decisionToState.map( (ds: antlr.DecisionState, index: number) => new antlr.DFA(ds, index) );
}